// ── red.app v2 — i18n bundle (DE / EN) ────────────────────────────
// Source: design_handoff/data.js → RED_DATA.STR + project-specific keys.

export const STR = {
  de: {
    // ── nav / common ──────────────────────────────────────────────
    dashboard: 'Dashboard',
    portfolio: 'Portfolio',
    markets: 'Märkte',
    transactions: 'Transaktionen',
    reports: 'Berichte',
    alerts: 'Alerts',
    settings: 'Einstellungen',
    profile: 'Profil',
    premium: 'Premium',
    vip: 'VIP',
    free: 'Free',

    // ── dashboard ─────────────────────────────────────────────────
    hello: 'Guten Tag',
    total_portfolio: 'Gesamtportfolio',
    invested: 'Investiert',
    unrealized: 'Unrealisiert',
    realized: 'Realisiert',
    positions: 'Positionen',
    change_24h: '24h Änderung',
    allocation: 'Allokation',
    your_assets: 'Deine Assets',
    recent_activity: 'Letzte Aktivität',
    view_all: 'Alle ansehen',
    top_mover: 'Top Mover',
    since_entry: 'seit Einstieg',

    // ── transactions ──────────────────────────────────────────────
    all_transactions: 'Alle Transaktionen',
    import: 'Importieren',
    import_d: 'Lade deine Exchange-Exporte hoch (Binance, Kraken, Coinbase…)',
    add_tx: 'Transaktion hinzufügen',
    manual: 'Manuell',
    csv_import: 'CSV-Import',
    api_import: 'API / Exchange',
    photo_import: 'Foto / Screenshot',
    manual_d: 'Trage Käufe, Verkäufe und Transfers von Hand ein.',
    csv_d: 'Lade deine Exchange-Exporte hoch (Binance, Kraken, Coinbase…).',
    api_d: 'Verbinde Read-Only-API-Keys für automatisches Tracking.',
    photo_d: 'Importiere via Foto oder Screenshot — KI erkennt Werte automatisch.',
    popular_exchanges: 'Beliebte Börsen',

    // ── markets ───────────────────────────────────────────────────
    market_overview: 'Marktübersicht',
    buy_x: '{x} kaufen',
    price: 'Preis',
    change_7d: '7T',
    market_cap: 'Marktkapitalisierung',
    volume: 'Volumen 24h',
    sort_by: 'Sortieren',
    search_markets: 'Suche Coins…',
    live_coingecko: 'Live · CoinGecko',
    n_coins: '{n} Coins',

    // ── reports ───────────────────────────────────────────────────
    tax_year: 'Berichtsjahr',
    fifo_calc: 'FIFO',
    taxable_events: 'Ereignisse',
    tax_obligation: 'Indikativer Wert (26 %)',
    of_which_free: 'Davon außerhalb Haltefrist',
    tax: 'Info',
    kept: 'Behalten',
    pdf_report: 'Bericht · PDF',
    report_year: 'Geschäftsjahr',
    sales_count: 'Verkäufe',
    pdf_history: 'Bericht · PDF',
    total_pnl: 'Gewinn / Verlust',
    tax_disclaimer: 'Hinweis: Red. ist kein Steuer-Tool. Alle Angaben sind unverbindliche Informationen ohne Gewähr und ersetzen keine Steuerberatung.',

    // ── alerts ────────────────────────────────────────────────────
    add_alert: 'Alert hinzufügen',
    price_above: 'Preis über',
    price_below: 'Preis unter',

    // ── common ────────────────────────────────────────────────────
    coin: 'Coin',
    amount: 'Menge',
    value: 'Wert',
    type: 'Typ',
    date: 'Datum',
    buy: 'Kauf',
    sell: 'Verkauf',
    swap: 'Tausch',
    deposit: 'Einzahlung',
    withdrawal: 'Auszahlung',
    bought: 'gekauft',
    sold: 'verkauft',
    swapped: 'getauscht',
    received: 'empfangen',
    sent: 'gesendet',
    verified: 'On-Chain verifiziert',
    cancel: 'Abbrechen',
    save: 'Speichern',
    delete: 'Löschen',
    confirm: 'Bestätigen',
    back: 'Zurück',
    next: 'Weiter',
    close: 'Schließen',
    today: 'Heute',

    // ── ads ───────────────────────────────────────────────────────
    sponsored: 'Anzeige',
    ad_placeholder_eyebrow: 'WERBEPLATZ',
    ad_placeholder_type: 'Reserviert',
    ad_placeholder_title: 'Hier könnte deine Marke stehen.',
    ad_placeholder_sub: 'Premium-Anzeigenplatz im Dashboard — kontaktiere uns für Partnerschaften.',
    ad_placeholder_cta: 'Mehr erfahren',
    ad_placeholder2_eyebrow: 'WERBEPLATZ',
    ad_placeholder2_type: 'Verfügbar',
    ad_placeholder2_title: 'Reichweite, die zählt.',
    ad_placeholder2_sub: 'Krypto-affine Zielgruppe direkt im Portfolio-Workflow erreichen.',
    ad_placeholder2_cta: 'Kontakt',

    // ── asset detail ──────────────────────────────────────────────
    overview: 'Übersicht',
    tax_status: 'Haltefrist-Status',
    action: 'Aktion',
    holdings: 'Bestand',
    avg_price: 'Ø Kaufpreis',
    current_price: 'Aktueller Kurs',
    pnl: 'Gewinn / Verlust',
    tx_history: 'Transaktionen',
    buy_more: 'Mehr kaufen',
    course: 'Kursverlauf',

    // ── smart check / tax timeline ────────────────────────────────
    smart_check: 'Smart Check',
    holding_period: 'Haltefrist',
    tax_free: 'Über der Frist',
    taxable: 'Innerhalb Frist',
    holding_d: 'Hinweis: In DE werden private Krypto-Veräußerungen i. d. R. nach Ablauf der 1-Jahres-Frist (§ 23 EStG) anders behandelt. Keine Steuerberatung — bitte mit Steuerberater prüfen.',
    next_milestone: 'Nächster Meilenstein',
    days_remaining: 'Tage verbleibend',
    full_tax_free: 'Vollständig außerhalb Haltefrist',
    lots: 'FIFO-Tranchen',
    since: 'seit',
    tax_free_in_x_days: 'In {days} Tagen liegen weitere {amount} {sym} außerhalb der 1-Jahres-Frist.',
    pct_of_x_is_free: '{pct} % deines {sym}-Bestands sind außerhalb der 1-Jahres-Frist.',
    free_check: 'außerhalb Frist',
    days_short: 'T',

    // ── profile ──────────────────────────────────────────────────
    appearance: 'Erscheinungsbild',
    dark_mode: 'Dark Mode',
    member_since: 'Mitglied seit',
    language: 'Sprache',
    currency: 'Währung',
    security_2fa: 'Sicherheit · 2FA',
    connected_exchanges: 'Verbundene Exchanges',
    plan_status: 'Plan',
    plan_free: 'Kostenlos',
    upgrade_premium: 'Upgrade · 4,99 € (einmalig)',
    redeem_code: 'Code einlösen',
    delete_data: 'Alle Daten löschen',
    delete_confirm: 'Wirklich alle Daten unwiderruflich löschen?',
    name: 'Name',

    // ── tagline ──────────────────────────────────────────────────
    tagline: 'Krypto-Portfolio, klar überblickt.',
    brand_footer: 'red.app · v1.0',

    // ── shell / nav (desktop + mobile) ────────────────────────────
    plans: 'Tarife',
    transaction: 'Transaktion',
    sign_out: 'Abmelden',
    light_mode: 'Light-Mode',
    search_placeholder: 'Coins, Transaktionen, Befehle …',
    quick_search: 'Schnellsuche',
    support: 'Support',
    collapse_sidebar: 'Einklappen',
    expand_sidebar: 'Ausklappen',
    connect: 'Verbinden',
    upgrade: 'Upgrade',
    per_year: '/ Jahr',
    premium_promo_features: 'Reports · KI-Import · Börsen-API',
    account: 'Konto',
    your_data_gdpr: 'Deine Daten · DSGVO',
    privacy: 'Datenschutz',
    privacy_gdpr: 'Datenschutz & DSGVO',
    eu_hosting: 'EU-Hosting',
    theme: 'Theme',
    private_mode: 'Privat-Modus',
    private_visible: 'Sichtbar',
    private_hidden: 'Verborgen',
    connected_sources: 'Verbundene Quellen',
    no_sources_connected: 'Noch keine Quellen verbunden. Tippe auf „Verbinden“ um zu beginnen.',
    connected_since: 'Verbunden seit {date}',
    api_read_only: 'API · read-only',
    account_security: 'Konto-Sicherheit',
    security_login: '2FA & Anmelde-Sicherheit',
    coming_soon: 'Demnächst',
    manage_alerts: 'Alerts verwalten',
    redeem_vip_code: 'VIP-Code einlösen',
    export_data_json: 'Daten exportieren (JSON)',
    exporting: 'Exportiere…',
    delete_all_txs: 'Alle Transaktionen löschen',
    delete_account_full: 'Konto vollständig löschen',
    irreversible: 'unwiderruflich',
    usage: 'Nutzung',
    in_premium_5000: 'Unbegrenzt — kein TX-Limit',
    sources: 'Quellen',
    enter_name: 'Name eingeben',
    profile_settings_title: 'Profil & Einstellungen.',
    new_exchange_connect: '+ Neue Börse verbinden',
    loading: 'Lade…',
    no_api_connected: 'Noch keine API verbunden.',
    select_language: 'Sprache',
    select_currency: 'Währung',
    feedback_give: 'Feedback geben',
    feedback_mail_subject: 'Beta-Feedback',
    feedback_mail_body: 'Hi! Danke, dass du die Beta testest. Erzähl mir kurz:\n\n• Was gefällt dir?\n• Was fehlt dir / was wünschst du dir?\n• Was war verwirrend oder hat nicht funktioniert?\n\nJedes Detail hilft – danke!',
    tour_marker: 'Rundgang',
    tour_skip: 'Überspringen',
    tour_next: 'Weiter',
    tour_done: 'Los geht\'s',
    tour_welcome_eyebrow: 'Willkommen',
    tour_welcome_title: 'Schön, dass du da bist.',
    tour_welcome_body: 'Kurzer Rundgang – in 30 Sekunden zeige ich dir das Wichtigste.',
    tour_overview_eyebrow: 'Überblick',
    tour_overview_title: 'Dein ganzes Krypto, an einem Ort.',
    tour_overview_body: 'Das Dashboard zeigt deinen Gesamtwert und seine Entwicklung – über alle Börsen und Wallets hinweg.',
    tour_transactions_eyebrow: 'Transaktionen',
    tour_transactions_title: 'Jede Bewegung, sauber sortiert.',
    tour_transactions_body: 'Hier siehst du alle Käufe, Verkäufe und Transfers – automatisch zusammengeführt.',
    tour_add_eyebrow: 'Hinzufügen',
    tour_add_title: 'Börse, Wallet oder manuell.',
    tour_add_body: 'Über das + importierst du per CSV, Börsen-API oder Wallet-Adresse – oder trägst Transaktionen selbst ein.',
    tour_reports_eyebrow: 'Bericht',
    tour_reports_title: 'Nachweis, wenn du ihn brauchst.',
    tour_reports_body: 'Brauchst du einen sauberen Nachweis fürs Finanzamt, erzeugst du ihn hier als PDF oder Excel.',
    tour_privacy_eyebrow: 'Privat & gratis',
    tour_privacy_title: 'Read-only. Privat. Kostenlos.',
    tour_privacy_body: 'Wir lesen nur – deine Schlüssel bleiben deine. Kein Tracking, voller Umfang gratis. Los geht\'s!',
    redeem: 'Einlösen',
    copy: 'Kopieren',
    delete_all_data_q: 'Alle Daten löschen?',
    delete_account_q: 'Konto vollständig löschen?',
    creating: 'Erstelle…',

    // ── Dashboard ─────────────────────────────────────────────────
    dash_gain_unrealized: 'Gewinn (unrealisiert)',
    dash_vs_prefix: 'Das sind',
    dash_vs_suffix: ', als du eingezahlt hast.',
    dash_more: 'mehr',
    dash_less: 'weniger',
    dash_your_wealth: 'Dein Vermögen',
    dash_your_holdings: 'Dein Bestand',
    dash_stat_invested: 'eingezahlt',
    dash_stat_today: 'heute',
    dash_stat_values: 'Werte',
    dash_stat_sources: 'Börsen & Wallets',
    dash_safety_strong: 'Nur du siehst das.',
    dash_safety_rest: 'Verschlüsselt, read-only — wir können nichts an deinem Geld tun.',
    ad_label: 'Anzeige',
    ad_slot_title: 'Hier könnte deine Marke stehen.',
    ad_slot_sub: 'Premium-Platz im Dashboard.',
    ad_slot2_title: 'Erreiche Krypto-Nutzer.',
    ad_slot2_sub: 'Direkt im Portfolio-Workflow.',
    greet_morning: 'Guten Morgen',
    greet_day: 'Guten Tag',
    greet_evening: 'Guten Abend',
    dash_of_limit: 'von {limit}',
    dash_total_portfolio_full: 'Gesamtportfolio',
    dash_hero_headline_1: 'Dein Vermögen,',
    dash_hero_headline_2: 'in Bewegung.',
    dash_today: 'HEUTE',
    dash_gain: 'Gewinn',
    dash_history: 'Verlauf',
    dash_no_data: 'Noch keine Daten',
    dash_history_loading: 'Verlauf wird berechnet…',
    dash_history_empty: 'Sobald historische Preise vorliegen, erscheint hier dein tatsächlicher Portfolio-Wert über die Zeit.',
    dash_history_empty_title: 'Dein Verlauf entsteht',
    dash_position_one: 'Position',
    dash_invested_short: 'invest.',
    dash_alloc_collapse: 'Allokation ausblenden',
    dash_alloc_expand: 'Allokation einblenden',
    dash_asset: 'Asset',
    dash_return: 'Rendite',
    dash_n_hidden: '{n} ausgeblendet',
    dash_show: 'Einblenden',
    dash_hide: 'Ausblenden',
    dash_edit: 'Bearbeiten',
    dash_done: 'Fertig',
    dash_active_alerts: 'Aktive Alerts',
    dash_all_arrow: 'Alle ›',
    dash_no_active_alerts: 'Noch keine aktiven Alerts.',
    dash_create_now: 'Jetzt anlegen ›',
    dash_holding_period: 'Haltefrist',
    dash_activate: 'Aktivieren',
    dash_pause: 'Pausieren',
    dash_n_more: '+{n} weitere',
    dash_assets: 'Assets',
    dash_external_wallet: 'Externe Wallet',
    dash_derived_price: 'Abgeleitet aus dem historischen Tages-Schlusspreis',
    dash_empty_coins_1: 'Noch keine Coins.',
    dash_empty_coins_2: 'Tippe auf + um zu starten.',
    dash_no_transactions: 'Noch keine Transaktionen',

    // ── WalletScreen ──────────────────────────────────────────────
    wal_tab_sent: 'Gesendet',
    wal_tab_received: 'Empfangen',
    wal_tab_transfers: 'Transfers',
    wal_tab_inflows: 'Staking/Airdrop',
    wal_tab_staking: 'Staking',
    wal_tab_futures: 'Futures',
    wal_tab_fiat: 'Ein-/Auszahlung €',
    wal_tab_other: 'Sonstige',
    wal_irreversible: 'Unwiderruflich',
    wal_delete_single_title: 'Transaktion löschen?',
    wal_delete_bulk_title_one: '{count} Transaktion löschen?',
    wal_delete_bulk_title_many: '{count} Transaktionen löschen?',
    wal_delete_single_desc: 'Diese Transaktion wird unwiderruflich gelöscht. Bestände und FIFO-Berechnungen werden neu kalkuliert.',
    wal_delete_desc_selection_pre: 'Die ',
    wal_delete_desc_selection_post: ' ausgewählten Transaktionen werden unwiderruflich gelöscht.',
    wal_delete_desc_all_pre: 'Es werden ',
    wal_delete_desc_all_count: 'alle {count}',
    wal_delete_desc_all_post: ' geladenen Einträge gelöscht — inklusive Handelsgebühren, Fiat-Bewegungen und NFT-Einträge, die in der Liste normalerweise ausgeblendet sind.',
    wal_delete_desc_filtered_pre: 'Alle Transaktionen mit ',
    wal_delete_desc_filtered_post: ' werden unwiderruflich gelöscht.',
    wal_delete_desc_filtered_generic: 'Alle gefilterten Transaktionen werden unwiderruflich gelöscht.',
    wal_deleting: 'Wird gelöscht…',
    wal_delete_final: 'Endgültig löschen',
    wal_back_to_dashboard: 'Zurück zum Dashboard',
    wal_close_filter: 'Filter schließen',
    wal_eyebrow_history: 'Lückenlose Historie',
    wal_title_dot: 'Transaktionen.',
    wal_loaded: 'geladen',
    wal_exchanges_wallets: 'Börsen & Wallets',
    wal_open_transfers: 'TX Check',
    wal_open_transfers_review: 'TX Check · prüfen',
    wal_open_transfers_filtered: 'Offene Transfers · gefiltert',
    wal_sub_calm: 'Automatisch zusammengeführt aus deinen Börsen und Wallets.',
    wal_filtered: 'gefiltert',
    wal_review: 'prüfen',
    wal_sources: 'Quellen',
    wal_type: 'Typ',
    wal_types: 'Typen',
    wal_source_ai: 'KI',
    wal_click_cards: 'Karten anklicken',
    wal_n_selected: '{count} ausgewählt',
    wal_reset_selection: 'Auswahl zurücksetzen',
    wal_exit_mode: 'Modus beenden',
    wal_delete_count: 'Löschen ({count})',
    wal_empty_title: 'Keine Transaktionen',
    wal_empty_desc: 'Füge deinen ersten Kauf hinzu.',
    wal_sort: 'Sortieren',
    wal_delete_individually: 'Einzeln löschen',
    wal_delete_filtered: 'Gefilterte löschen',
    wal_delete_all: 'Alle löschen',
    wal_search_placeholder: 'Coin, Exchange, Datum, Hash …',
    wal_actions: 'Aktionen',
    wal_open_transfer_one: 'Punkt zu klären',
    wal_open_transfer_many: 'Punkte zu klären',
    wal_review_now: 'Jetzt prüfen',
    wal_link_transfers: 'Transfers verbinden',
    wal_link_hint_first: 'Wähle die erste Buchung',
    wal_link_hint_second: 'Wähle die passende Gegenbuchung',
    wal_link_hint_ready: 'Bereit zum Verbinden',
    wal_tap_cards: 'Tippe Karten zum Markieren',
    wal_close_selection_mode: 'Auswahl-Modus schließen',
    wal_tx_count_one: '{count} Transaktion',
    wal_tx_count_many: '{count} Transaktionen',
    wal_no_results: 'Keine Treffer',
    wal_no_results_desc: 'Passe den Filter an oder setze ihn zurück.',
    wal_manually_sorted: 'manuell sortiert',
    wal_edit_order: 'Reihenfolge bearbeiten',
    wal_tap_cards_short: 'Karten antippen',
    wal_n_of_2_selected: '{count}/2 ausgewählt',
    wal_n_open_one: '{count} offene',
    wal_n_open_many: '{count} offene',
    wal_done: 'Fertig',
    wal_connect: 'Verbinden',

    // ── AssetDetailScreen ─────────────────────────────────────────
    asset_edit: 'Bearbeiten',
    asset_no_tx: 'Noch keine Transaktionen für {sym}',
    asset_dust_hidden: '{n} Mini-Eingänge (Dust) ausgeblendet',
    asset_chart_load_failed: 'Chart konnte nicht geladen werden',
    asset_retry: 'Erneut versuchen',
    asset_chart_loading: 'Lade Kursverlauf…',
    asset_analyse: 'Analyse',
    asset_analyse_subtitle: 'Performance & Cash-Flow im Detail',
    asset_hint_label: 'Hinweis',
    asset_exchange_hint: 'Bei einigen Käufen / Einzahlungen fehlt die Exchange-Angabe. Pflege das Feld nach, um wallet-spezifische FIFO zu ermöglichen.',
    asset_alert: 'Alarm',
    asset_export_action: 'Exportieren',
    asset_report_generating: 'Report wird erstellt…',
    asset_alarm: 'Alarm',
    asset_export_label: 'Export',
    asset_no_position: 'Du hältst {sym} noch nicht. Trage einen Kauf manuell ein oder importiere eine CSV.',
    asset_export_failed: 'Export fehlgeschlagen.',
    asset_position: 'Position',
    asset_chg_pre: 'Heute',
    asset_chg_more: 'mehr',
    asset_chg_less: 'weniger',
    asset_chg_post: 'als gestern',

    // ── MarketsScreen ─────────────────────────────────────────────
    mkt_sort_mcap: 'Market Cap',
    mkt_col_asset: 'Asset',
    mkt_col_24h: '24h',
    mkt_col_7d: '7T',
    mkt_col_mcap: 'Mkt-Cap',
    mkt_favorites: 'Favoriten',
    mkt_fav_add: 'Zu Favoriten hinzufügen',
    mkt_fav_remove: 'Aus Favoriten entfernen',
    mkt_live: 'Live',
    mkt_unit_trillion: 'Bio.',
    mkt_unit_billion: 'Mrd.',
    mkt_unit_million: 'Mio.',
    mkt_empty_favorites: 'Noch keine Favoriten — tippe auf den Stern bei einem Coin.',
    mkt_empty_coins: 'Keine Coins gefunden.',

    // ── TaxScreen / Berichte ──────────────────────────────────────
    tax_unlock_premium: 'Premium freischalten',
    tax_unlock_sub: 'Einmaliger Kauf · API, Excel & PDF · 500+ Transaktionen',
    tax_feat_api: 'API-Anbindung',
    tax_feat_api_sub: 'Exchange direkt verbinden',
    tax_feat_export: 'Excel & PDF Export',
    tax_feat_export_sub: 'Druckfertig & strukturiert',
    tax_feat_txs: '500+ Transaktionen',
    tax_feat_txs_sub: 'Unbegrenzte Einträge',
    tax_total_price: 'Gesamtpreis',
    tax_no_vat: '(keine USt. — Kleinunternehmer § 19 UStG)',
    tax_waiver_text: 'Ich verlange ausdrücklich, dass mit der Bereitstellung der digitalen Inhalte vor Ablauf der Widerrufsfrist begonnen wird. Ich habe zur Kenntnis genommen, dass ich mit Beginn der Ausführung mein Widerrufsrecht verliere (§ 356 Abs. 5 BGB). Es gelten unsere',
    tax_waiver_terms: 'AGB',
    tax_waiver_and: 'und die',
    tax_waiver_privacy: 'Datenschutzerklärung',
    tax_order_paid: 'Zahlungspflichtig bestellen',
    tax_cancel: 'Abbrechen',
    tax_no_acquisition: 'Keine Anschaffung gefunden — Anschaffungsbasis unbekannt.',
    tax_in_holding: 'In Haltefrist',
    tax_over_year: 'Über 1-Jahres-Frist',
    tax_swap: 'Tausch',
    tax_loss: 'Verlust',
    tax_proceeds: 'Erlös',
    tax_acquisition: 'Anschaffung',
    tax_fee: 'Gebühr',
    tax_result: 'Ergebnis',
    tax_fifo_match: 'FIFO-Match · Anschaffungen',
    tax_warn_cost_basis: 'Anschaffungsbasis unbekannt — Ergebnis nicht berechenbar.',
    tax_warn_incomplete: 'FIFO konnte nicht alle Anteile matchen.',
    tax_warn_fallback: 'Wallet-übergreifender Match wegen unvollständiger Daten.',
    tax_event: 'Ereignis',
    tax_events: 'Ereignisse',
    tax_paid_out: 'Ausbezahlt',
    tax_result_fifo: 'Ergebnis · FIFO',
    tax_today_live: 'Heute · Live',
    tax_in_holdings: '{amount} im Bestand',
    tax_no_remaining: 'Kein Restbestand',
    tax_holding_status: 'Haltefrist-Status',
    tax_choose_coin: 'Coin wählen',
    tax_generating: 'Wird erstellt…',
    tax_export_report: 'Bericht exportieren',
    tax_open_detail: 'Detailansicht',
    tax_sc_title: 'Wann erreicht deine Position die 1-Jahres-Frist?',
    tax_sc_sub: 'Jede FIFO-Tranche als eigener Balken. Heute-Linie, Countdown in Tagen, grüner Tick am Stichtag.',
    tax_pct_of_holdings: 'deines {coin}-Bestands',
    tax_over_1y_period: 'über der 1-Jahres-Frist',
    tax_market_value: 'Marktwert',
    tax_current_live_price: 'aktueller Live-Preis',
    tax_in_prefix: 'In',
    tax_n_days: '{n} Tagen',
    tax_next_tranche_mid: 'überschreiten weitere',
    tax_next_tranche_suffix: 'die Frist.',
    tax_all_tranches_free: 'Alle Tranchen sind über der 1-Jahres-Frist.',
    tax_free_legend: 'frei',
    tax_bound_legend: 'gebunden',
    tax_decl_no: 'Erklärung № {n}',
    tax_decl_official: 'Amtlich · red.app',
    tax_decl_page: 'Seite 01 · 01',
    tax_decl_subject: 'Gegenstand',
    tax_decl_facts: 'Sachverhalt',
    tax_sc_decl_headline: 'Wir sind keine Steuerberater — und wir tun auch nicht so.',
    tax_sc_decl_body: 'Berichte für das Finanzamt erstellen wir nicht; dafür fehlt uns die Lizenz. Was wir liefern: lückenlose Transaktionshistorien, sauber aufgearbeitet, mit Grafiken. Das reicht meistens fürs Finanzamt — oder du gibst sie an deinen Steuerberater. Ab Premium kostenlos.',
    tax_coin_search_ph: 'Suchen, z. B. BTC, ETH, SHIB…',
    tax_no_coin_found: 'Kein Coin gefunden.',
    tax_active: 'Aktiv',
    tax_annual_report: 'Jahresbericht',
    tax_export: 'Exportieren',
    tax_realized_gain: 'Realisierter Gewinn',
    tax_realized_loss: 'Realisierter Verlust',
    tax_fifo_over_sales: 'Aus allen Verkäufen und Tauschvorgängen, in der Reihenfolge des Kaufs (FIFO).',
    tax_avg_over_sales: 'Aus allen Verkäufen und Tauschvorgängen, mit gleitendem Durchschnitt gerechnet.',
    tax_method_long: 'gleitendem Durchschnitt',
    tax_event_in_year: 'Vorgang gezählt.',
    tax_events_in_year: 'Vorgänge gezählt.',
    tax_realized_gain_fifo: 'Gewinn aus Verkäufen · FIFO',
    tax_realized_loss_fifo: 'Verlust aus Verkäufen · FIFO',
    tax_realized_gain_average: 'Gewinn aus Verkäufen · gleitender Durchschnitt',
    tax_realized_loss_average: 'Verlust aus Verkäufen · gleitender Durchschnitt',
    tax_cost_of_sold: 'Einkauf der verkauften Coins:',
    tax_loss_carry: 'Verrechenbarer Verlust',
    tax_model_deduction_26: 'Rechnerischer Abzug (26%)',
    tax_model_deduction_275: 'Rechnerischer Abzug (27,5%)',
    tax_method_average: 'Ø-Preis',
    tax_model_deduction: 'Rechnerischer Abzug',
    tax_offsettable: 'Verrechenbar mit künftigen Gewinnen',
    tax_calc_26_flat: 'Unverbindliche Beispielrechnung',
    tax_calc_flat: 'Unverbindliche Beispielrechnung',
    tax_kept_share: 'Davon behältst du',
    tax_after_model_deduction: 'nach dem rechnerischen Abzug',
    tax_held_over_year: 'Über 1 Jahr gehalten',
    tax_held_over_year_sub: 'Haltefrist erfüllt — bleibt dir komplett',
    tax_held_under_year: 'Unter 1 Jahr gehalten',
    tax_held_under_year_gain_sub: 'Haltefrist offen — hier greift der rechnerische Abzug',
    tax_held_under_year_loss_sub: 'Verlust — mit künftigen Gewinnen verrechenbar',
    tax_deduction_this_year: 'Rechnerischer Abzug dieses Jahr',
    tax_you_keep: 'Du behältst',
    tax_you_keep_pct: '{pct} % deines Ergebnisses',
    tax_flow_title: 'So entsteht dein Ergebnis',
    tax_flow_proceeds: 'Verkaufserlös',
    tax_flow_cost: '− Einkauf',
    tax_flow_result_gain: '= Gewinn',
    tax_flow_result_loss: '= Verlust',
    tax_flow_note_gain: 'Der Großteil von dem, was reinkam, war dein eigenes Geld zurück. Nur der grüne Teil ist echter Gewinn.',
    tax_flow_note_loss: 'Du hast weniger zurückbekommen, als du ursprünglich investiert hattest.',
    tax_by_holding: 'Davon nach Haltedauer',
    tax_keep_all: 'Zurücklegen musst du rechnerisch nichts — der ganze Gewinn bleibt dir.',
    tax_keep_some: 'Leg dafür rechnerisch {ded} zurück — dir bleiben {kept}.',
    tax_details_show: 'Details anzeigen',
    tax_details_hide: 'Details ausblenden',
    tax_answer_keep_all_title: 'Du behältst alles.',
    tax_answer_keep_all_sub: 'Zurücklegen musst du dieses Jahr rechnerisch nichts.',
    tax_answer_keep_some_title: 'Leg dafür rechnerisch {ded} zurück.',
    tax_answer_keep_some_sub: 'Den Rest behältst du — dir bleiben {kept}.',
    tax_answer_loss_title: 'Unterm Strich ein Verlust.',
    tax_answer_loss_sub: 'Verrechenbar mit künftigen Gewinnen.',
    tax_answer_loss_sub_at: 'Nur im selben Kalenderjahr verrechenbar.',
    tax_total: 'Gesamt',
    tax_balance_btn: 'Bilanz ansehen',
    tax_balance_title: 'Deine Bilanz {year}',
    tax_balance_intro: 'So setzt sich dein Ergebnis genau zusammen.',
    tax_bal_intro: 'Länger als ein Jahr gehalten zählt nicht mit, kürzeres zählt.',
    tax_bal_over: 'ÜBER 1 JAHR',
    tax_bal_under: 'UNTER 1 JAHR',
    tax_bal_sale: 'Verkauf',
    tax_bal_sales: 'Verkäufe',
    tax_bal_result: 'Ergebnis',
    tax_dur_y: 'J',
    tax_dur_m: 'M',
    tax_bal_at_intro: 'Altvermögen (vor 1.3.2021) bleibt frei — Neuvermögen zählt, ohne Haltefrist.',
    tax_bal_at_free: 'ALTVERMÖGEN',
    tax_bal_at_tax: 'NEUVERMÖGEN',
    tax_carryloss_note_at: 'Unterm Strich ein Verlust — nur im selben Kalenderjahr verrechenbar (kein Vortrag).',
    tax_at_alt_label: 'Altvermögen · frei',
    tax_at_alt_sub: 'vor 1.3.2021, über 1 Jahr — zählt nicht',
    tax_at_gain_label: 'Gewinn · Neuvermögen',
    tax_at_deduction: 'Rechnerisch {pct} %',
    tax_at_remains: 'Dir bleiben',
    tax_at_keep_pct: 'dir bleibt {pct} %',
    tax_at_setaside_pct: '{pct} % zurücklegen',
    tax_at_disclaimer: 'Verlust nur im selben Kalenderjahr verrechenbar (kein Vortrag). Krypto-Tausch ist neutral — keine Realisierung.',
    tax_inline_disclaimer_long: 'Pauschale Modellrechnung mit {pct} % auf den realisierten Gewinn — kein Bescheid, keine verbindliche Auskunft, keine Berücksichtigung individueller Freibeträge, Verluste oder Sonderfälle. Für deine konkrete Belastung bitte den eigenen Steuerberater oder das Finanzamt fragen.',
    tax_inline_disclaimer_short: 'Pauschalrechnung {pct} % — kein amtlicher Bescheid, keine verbindliche Auskunft.',
    tax_calc_notes: 'Hinweise zur Berechnung',
    tax_split_title: 'Aufteilung deines Ergebnisses',
    tax_relevant_event: 'einbezogener Vorgang',
    tax_relevant_events: 'einbezogene Vorgänge',
    tax_turnover: 'Umsatz',
    tax_realized: 'Gewinn / Verlust',
    tax_sold: 'verkauft',
    tax_swapped: 'getauscht',
    tax_today: 'Heute',
    tax_basis_incomplete: 'Basis unvollständig',
    tax_decl_annual_report: 'Jahresbericht · red.app',
    tax_rp_decl_headline: 'Was du hier siehst — und was nicht.',
    tax_rp_decl_body: 'Eine auf {method} basierende Aufstellung deiner realisierten Ergebnisse {year}. Kein amtlicher Bescheid, keine verbindliche Auskunft. Reicht in den meisten Fällen fürs Finanzamt oder als Vorlage für deinen Steuerberater. Vollständiger Export ab Premium.',
    tax_export_failed: 'Export fehlgeschlagen.',
    tax_empty_title: 'Noch keine Transaktionen',
    tax_empty_line1: 'Füge Transaktionen hinzu, um',
    tax_empty_line2: 'deinen Bericht zu sehen.',
    tax_carryloss_note: 'Unterm Strich ein Verlust — verrechenbar mit künftigen Gewinnen.',
    tax_your_coins: 'Deine Coins',
    tax_premium_hint: 'Vollständiger Jahres-Export ab € 19 (einmalig) oder Premium € 49 / Jahr',

    // ── PricingScreen ─────────────────────────────────────────────
    price_eyebrow: 'Preise',
    price_title: 'Vier Wege, kein Probe-Quatsch.',
    price_subtitle: 'Den Großteil der Vorteile bekommst du schon im Free-Paket — Reports gibt\'s für kleines Geld dazu.',
    price_note_forever: 'für immer',
    price_note_per_year_once: 'einmalig',
    price_note_per_year_month: 'pro Jahr · €{month}/Mo.',
    price_note_per_year: 'pro Jahr',
    price_feat_free_unlimited: 'Unbegrenzte Transaktionen',
    price_feat_free_track: 'Eingabe, Tracking, Übersichten',
    price_feat_free_live: 'Live-Kurse via CoinGecko',
    price_feat_free_import: 'Manueller + CSV Import',
    price_feat_free_reports_addon: 'Reports zukaufbar (€{price} / Jahr)',
    price_feat_report_excel_pdf: 'Excel + PDF Report eines Jahres',
    price_feat_report_all_tx: 'Bis 500 Transaktionen / Jahr',
    price_feat_report_charts: 'Mit Grafiken fürs Finanzamt',
    price_feat_report_no_sub: 'Ohne Abo — einzeln kaufbar',
    price_feat_premium_5000tx: 'Reports bis 5.000 TX / Jahr',
    price_feat_premium_ai_upload: 'Foto- & CSV-Upload mit KI',
    price_feat_premium_free_reports: 'Kostenlose Excel + PDF Reports',
    price_feat_premium_per_coin: 'Reports pro Coin (mit Grafiken)',
    price_feat_premium_smart_check: 'Smart Check (Haltefrist, DE)',
    price_feat_premium_exchange_apis: 'Börsen-APIs (nur lesen)',
    price_feat_vip_all_premium: 'Alles aus Premium',
    price_feat_vip_unlimited: 'Reports ohne TX-Limit',
    price_feat_vip_priority: 'Priorisierter Support',
    price_feat_vip_early_access: 'Early-Access neue Features',
    price_feat_vip_code: 'Per Einladungs-Code freischaltbar',
    price_cta_free_start: 'Kostenlos starten',
    price_cta_report_buy: 'Report kaufen',
    price_cta_premium_unlock: 'Premium freischalten',
    price_cta_vip_become: 'VIP werden',
    price_cta_current_plan: 'Aktueller Plan',
    price_cta_already_bought: 'Bereits für {year} gekauft',
    price_cta_in_your_plan: 'In deinem Plan enthalten',
    price_cta_in_vip: 'In VIP enthalten',
    price_activating: 'Wird aktiviert…',
    price_report_kicker: 'Einmalig · kein Abo',
    price_report_headline: 'Dein Nachweis fürs Finanzamt.',
    price_report_seal: 'red. geprüft',
    price_report_doc_title: 'JAHRESBERICHT',
    price_trust_gdpr: 'DSGVO-konform',
    price_trust_eu: 'Server in der EU',
    price_trust_no_advice: 'Keine Steuerberatung',
    price_trust_bayern: 'Made in Bayern',
    price_trust_cancel: 'Kein Abo, kein Auto-Verlängern',

    // ── AlertsScreen ──────────────────────────────────────────────
    alert_line_rises_above: '{coin} steigt über',
    alert_line_falls_below: '{coin} fällt unter',
    alert_line_moves: '{coin} bewegt sich',
    alert_line_holding_period: '{coin} · 1-Jahres-Frist',
    alert_line_position_at: '{coin} Position bei',
    alert_line_portfolio_at: 'Portfolio bei',
    alert_pause: 'Pausieren',
    alert_activate: 'Aktivieren',
    alert_once: 'Einmalig',
    alert_recurring: 'Wiederkehrend',
    alert_last_triggered: 'zuletzt {date}',
    alert_created_at: 'erstellt {date}',
    alert_delete_aria: 'Alert löschen',
    alert_coin_search_placeholder: 'Coin suchen … z. B. Bitcoin, SOL, PEPE',
    alert_no_coin_found: 'Kein Coin gefunden.',
    alert_cond_price_above: 'Steigt über',
    alert_cond_price_below: 'Fällt unter',
    alert_cond_pct_change: '± Bewegung 24 h (%)',
    alert_cond_holding_period: 'Haltefrist (1-Jahres-Frist)',
    alert_cond_position_value: 'Positions-Wert ({sym})',
    alert_cond_portfolio_value: 'Portfolio-Wert ({sym})',
    alert_new_alert: 'Neuer Alert',
    alert_condition: 'Bedingung',
    alert_change: 'ändern',
    alert_value_warn_days: 'Vorwarnzeit (Tage)',
    alert_value_percent: 'Prozent (%)',
    alert_value_portfolio: 'Portfolio-Wert ({sym})',
    alert_value_position: 'Positions-Wert ({sym})',
    alert_value_target_price: 'Zielpreis ({sym})',
    alert_err_days_range: 'Bitte 1–365 Tage eingeben',
    alert_err_invalid_value: 'Bitte einen gültigen Wert eingeben',
    alert_err_create_failed: 'Konnte Alert nicht erstellen. Bitte erneut versuchen.',
    alert_current: 'Aktuell:',
    alert_holding_hint: 'Vorwarnung, bevor eine {coin}-Tranche die 1-Jahres-Frist erreicht.',
    alert_created_ok: 'Alert erstellt',
    alert_creating: 'Erstelle…',
    alert_create: 'Alert erstellen',
    alert_confirm_delete: 'Diesen Alert wirklich löschen?',
    alert_confirm_disable_push: 'Push-Benachrichtigungen deaktivieren? Du kannst sie jederzeit wieder aktivieren.',
    alert_push_enable_failed: 'Aktivierung fehlgeschlagen. Bitte erneut versuchen.',
    alert_empty_title: 'Noch keine Alerts',
    alert_empty_hint_below: 'Erstelle deinen ersten unten.',
    alert_empty_hint_right: 'Erstelle deinen ersten rechts.',
    alert_one_moment: 'Moment…',
    alert_push_disable: 'Push-Benachrichtigungen deaktivieren',
    alert_activating: 'Aktiviere…',
    alert_push_enable: 'Push-Benachrichtigungen aktivieren',
    alert_eyebrow: 'Preis & Haltefrist',
    alert_title_heading: 'Alerts.',
    alert_subtitle: 'Wir benachrichtigen dich, wenn ein Kurs deine Schwelle erreicht — oder wenn eine FIFO-Tranche die 1-Jahres-Frist überschreitet.',
    alert_banner_unsupported_title: 'Push nicht unterstützt',
    alert_banner_unsupported_body: 'Dein Browser unterstützt keine Push-Benachrichtigungen. Du kannst Alerts trotzdem anlegen — sie werden zugestellt, sobald du red. in einem unterstützten Browser öffnest.',
    alert_banner_blocked_title: 'Benachrichtigungen blockiert',
    alert_banner_blocked_body: 'Du hast Benachrichtigungen für red. blockiert. Aktiviere sie in den Browser-Einstellungen, damit Alerts dich erreichen.',
    alert_banner_ios_title: 'iPhone-Tipp',
    alert_banner_ios_body: 'Tippe in Safari auf Teilen → „Zum Home-Bildschirm" und öffne red. von dort, um Push zu aktivieren.',

    // ── ProfileScreen (Desktop + Mobile) ──────────────────────────
    prof_theme_dark: 'Dark',
    prof_theme_light: 'Light',
    prof_lang_de_name: 'Deutsch',
    prof_2fa_login_security: '2FA & Anmelde-Sicherheit',
    prof_beta: 'Beta',
    prof_program_suffix: 'Programm',
    prof_beta_headline_pre: 'Aktivste Tester bekommen ',
    prof_beta_headline_accent: '1 Jahr VIP',
    prof_beta_headline_post: ' umsonst.',
    prof_beta_sub: 'Bug gemeldet, Idee eingereicht, Feedback gegeben — wir sehen es.',
    prof_vip_code_desc: 'Gib deinen VIP-Code ein, um alle Funktionen freizuschalten.',
    prof_owner_gift_code: 'Owner · Code verschenken',
    prof_vip_once_redeemable: '1 Jahr VIP · einmalig einlösbar',
    prof_create_vip_code: 'Neuen VIP-Code erstellen',
    prof_your_data_gdpr_paren: 'Deine Daten (DSGVO)',
    prof_delete_account_short_pre: 'Diese Aktion entfernt dein Konto, alle Transaktionen, Verbindungen und Einstellungen ',
    prof_delete_account_short_post: '.',
    prof_deleting: 'Lösche…',
    prof_delete_account_btn: 'Konto löschen',
    prof_delete_account_intro_pre: 'Diese Aktion ist ',
    prof_delete_account_intro_post: '. Es werden gelöscht:',
    prof_delete_item_txs: 'Alle Transaktionen, Einstellungen und Profil-Daten',
    prof_delete_item_imports: 'Hochgeladene Import-Dateien',
    prof_delete_item_login: 'Dein Anmelde-Konto (E-Mail / Google-Login)',
    prof_delete_export_tip: 'Tipp: Exportiere deine Daten vorher.',
    prof_delete_final_btn: 'Endgültig löschen',
    prof_export_failed: 'Export fehlgeschlagen: {msg}',
    prof_account_delete_failed: 'Konto-Löschung fehlgeschlagen: {msg}',
    prof_unknown_error: 'Unbekannter Fehler',
    prof_reauth_required: 'Bitte melde dich neu an und versuche es erneut (aus Sicherheitsgründen).',
    prof_vip_err_used: 'Dieser Code wurde bereits eingelöst.',
    prof_vip_err_invalid: 'Code unbekannt. Bitte prüfe die Eingabe.',
    prof_vip_err_empty: 'Bitte gib einen Code ein.',
    prof_vip_err_generic: 'Einlösen fehlgeschlagen. Bitte später erneut versuchen.',
    prof_code_create_failed: 'Code konnte nicht erstellt werden.',

    // ── TransactionWizard ─────────────────────────────────────────
    tw_method_eyebrow: 'Hinzufügen',
    tw_method_title: 'Transaktion erfassen',
    tw_method_sub: 'Lückenlos erfasst, klar im Blick.',
    tw_method_connect_label: 'Direkt verbinden',
    tw_method_manual_sub: 'Trage Käufe, Verkäufe und Transfers von Hand ein.',
    tw_method_csv_sub: 'Lade Exchange-Exporte hoch (Binance, Kraken, Coinbase, MoonPay…).',
    tw_method_api_sub: 'Verbinde Read-Only-API-Keys für automatisches Tracking.',
    tw_method_wallet_title: 'Phantom Wallet verbinden',
    tw_method_wallet_sub: 'Phantom verbinden — Swaps & Transfers automatisch holen.',
    tw_type_eyebrow: 'Schritt 1',
    tw_type_title: 'Was hast du gemacht?',
    tw_type_sub: 'Wähle die Transaktionsart.',
    tw_type_buy_sub: 'Mit Euro gekauft',
    tw_type_sell_sub: 'Gegen Euro verkauft',
    tw_type_swap_sub: 'Coin gegen Coin',
    tw_type_received: 'Empfangen',
    tw_type_received_sub: 'Transfer erhalten',
    tw_type_sent: 'Gesendet',
    tw_type_sent_sub: 'Transfer gesendet',
    tw_type_fiat_in: 'Einzahlung',
    tw_type_fiat_in_sub: 'Geld auf die Börse',
    tw_type_fiat_out: 'Auszahlung',
    tw_type_fiat_out_sub: 'Geld auf die Bank',
    tw_fiat_in_sub: 'Bargeld von der Bank auf eine Börse.',
    tw_fiat_out_sub: 'Auszahlung von einer Börse auf die Bank.',
    tw_type_reward: 'Reward',
    tw_type_reward_sub: 'Staking / Zinsen',
    tw_type_staking: 'Staking',
    tw_type_staking_sub: 'Staking-Belohnung',
    tw_type_interest: 'Zinsen',
    tw_type_interest_sub: 'Verleih / Lending',
    tw_type_airdrop: 'Airdrop',
    tw_type_airdrop_sub: 'Gratis erhalten',
    tw_type_loss: 'Verlust',
    tw_type_loss_sub: 'Diebstahl / Hack',
    tw_type_futures: 'Futures PnL',
    tw_type_futures_sub: 'Gewinn / Verlust',
    tw_type_funding: 'Gebühr',
    tw_type_funding_sub: 'Funding-Fee',
    tw_pnl_label: 'Gewinn / Verlust',
    tw_pnl_ph: 'z. B. -50 oder 120',
    tw_pnl_hint: 'Negativ = Verlust/Kosten, positiv = Gewinn.',
    tw_coin_eyebrow: 'Schritt 2',
    tw_coin_title: 'Welcher Coin?',
    tw_coin_sub: 'Suche und wähle einen Coin.',
    tw_coin_sub_selected: 'Tippe einen anderen Coin oder gehe weiter.',
    tw_coin_search_ph: 'Bitcoin, ETH, XRP...',
    tw_coin_search_inline: 'Coin suchen...',
    tw_change: 'ändern',
    tw_src_title: 'Was für ein Transfer war das?',
    tw_src_sub: 'damit wir die Transaktion korrekt verbuchen.',
    tw_src_own_in: 'Von eigener Wallet / Börse',
    tw_src_own_out: 'An eigene Wallet / Börse',
    tw_src_own_sub: 'Transfer zwischen meinen eigenen Wallets — wird automatisch mit dem Gegenstück verknüpft.',
    tw_src_ext_in: 'Von Freund / externer Person',
    tw_src_ext_out: 'An Freund / externe Person',
    tw_src_ext_sub: 'Keine Gegen-Transaktion erwartet — wird nicht als ungematcht geflaggt.',
    tw_src_gift_in: 'Geschenk erhalten / als Bezahlung',
    tw_src_gift_out: 'Als Geschenk / Bezahlung gesendet',
    tw_src_gift_sub_in: 'Wird als Erwerb zum Marktwert verbucht.',
    tw_src_gift_sub_out: 'Wird als Veräußerung zum Marktwert verbucht.',
    tw_src_own_short: 'Eigene Wallet',
    tw_src_ext_short: 'Extern / Freund',
    tw_details_eyebrow: 'Details',
    tw_details_sub: 'Trage die Details ein.',
    tw_total: 'Gesamtbetrag',
    tw_unit_price: 'Stückpreis',
    tw_unit_price_auto: 'Stückpreis (auto)',
    tw_value_at_time: 'Wert zum Zeitpunkt (optional)',
    tw_rate: 'Kurs',
    tw_fee: 'Gebühr',
    tw_fee_incl: 'Gebühr (im Trade enthalten)',
    tw_network_fee: 'Netzwerk-Gebühr',
    tw_exchange: 'Exchange',
    tw_exchange_wallet: 'Exchange / Wallet',
    tw_to_exchange: 'An welche Börse',
    tw_from_exchange: 'Von welcher Börse',
    tw_pick_exchange_title: 'Quelle wählen',
    tw_pick_search: 'Suchen …',
    tw_pick_exchanges: 'Börsen',
    tw_pick_hw: 'Hardware-Wallets',
    tw_pick_sw: 'Software-Wallets',
    tw_pick_other: 'Sonstiges',
    tw_pick_empty: 'Nichts gefunden',
    tw_date_today: 'Heute',
    tw_txhash: 'TX-Hash',
    tw_txhash_opt: 'TX-Hash (optional)',
    tw_note: 'Notiz',
    tw_note_opt: 'Notiz (optional)',
    tw_note_ph_dca: 'z.B. DCA, Staking...',
    tw_note_ph_uniswap: 'z.B. Uniswap, DeFi...',
    tw_note_ph_from: 'z.B. von Bitpanda...',
    tw_note_ph_dca_airdrop: 'z.B. DCA, Airdrop…',
    tw_swap_title: 'Tausch-Details',
    tw_swap_sub: 'Was hast du gegen was getauscht?',
    tw_swap_coin_out: 'Abgegebener Coin (Von)',
    tw_swap_coin_in: 'Erhaltener Coin (Zu)',
    tw_swap_amount_out: 'Menge abgegeben',
    tw_swap_amount_in: 'Menge erhalten',
    tw_swap_value: 'Wert des Tauschs',
    tw_hist_price_missing: 'Kein historischer Kurs gefunden — Wert bitte manuell eintragen.',
    tw_transfer_external: 'Externer Transfer',
    tw_transfer_in_title: 'Transfer empfangen',
    tw_transfer_out_title: 'Transfer gesendet',
    tw_transfer_sub: 'trage Datum, Menge und Wallet ein.',
    tw_external_banner: 'Kein Gegenstück erwartet — die Transaktion wird nicht geflaggt.',
    tw_confirm_title: 'Alles korrekt?',
    tw_confirm_sub: 'Überprüfe deine Transaktion.',
    tw_confirm_link_sub: 'Optional: verknüpfe das passende Gegenstück.',
    tw_received_verb: 'empfangen',
    tw_sent_verb: 'gesendet',
    tw_link_counterpart: 'Gegenstück verknüpfen (optional)',
    tw_no_counterpart_title: 'Noch kein passendes Gegenstück gefunden',
    tw_no_counterpart_sub: 'Du kannst diese Transaktion nach dem Speichern manuell verknüpfen.',
    tw_save_and_link: 'Speichern & verknüpfen',
    tw_save_transfer: 'Transfer speichern',
    // Verbindungs-Sektion in der Edit-Maske (Web + Mobil)
    conn_title: 'Verbindung',
    conn_linked_to: 'Verbunden mit',
    conn_unlink: 'Trennen',
    conn_suggestions: 'Mögliche Gegenstücke',
    conn_link: 'Verbinden',
    conn_none_hint: 'Fehlt die Gegenbuchung (z. B. weil eine andere Börse das Asset nicht mehr exportiert), leg sie hier an — sie wird automatisch verbunden.',
    conn_create: 'Gegenbuchung anlegen',
    conn_create_in: 'Es wird ein Eingang als Gegenstück angelegt.',
    conn_create_out: 'Es wird eine Auszahlung als Gegenstück angelegt.',
    conn_create_exchange: 'Quelle/Ziel der Gegenbuchung',
    conn_create_confirm: 'Anlegen & verbinden',
    conn_busy: 'Einen Moment …',
    conn_wallet_label: 'Geliefert an (Wallet)',
    conn_wallet_none: '— keine —',
    tw_back: 'Zurück',
    tw_src_root_title: 'Wo gekauft?',
    tw_src_direct: 'Direkt auf der Börse',
    tw_src_direct_sub: 'z.B. Binance, Kraken, Bitvavo',
    tw_src_provider: 'Über Zahlungsdienstleister',
    tw_src_provider_sub: 'z.B. MoonPay → Ledger',
    tw_pick_provider_title: 'Zahlungsdienstleister',
    tw_pick_dest_title: 'Wohin geliefert?',
    tw_gift: 'Geschenk',
    tw_verb_kauf: 'gekauft',
    tw_verb_verkauf: 'verkauft',
    tw_verb_staking: 'als Reward erhalten',
    tw_verb_airdrop: 'als Airdrop erhalten',
    tw_verb_loss: 'verloren',
    tw_verb_einzahlung: 'erhalten',
    tw_verb_auszahlung: 'gesendet',
    tw_save_x: '{x} speichern',
    tw_transaction: 'Transaktion',
    tw_edit: 'Bearbeiten',
    tw_edit_swap: 'Tausch bearbeiten',
    tw_tx_type: 'Transaktionsart',
    tw_what_transfer: 'Was für ein Transfer?',
    tw_fiat_buy_q: 'War das ein Fiat-Kauf?',
    tw_switch: 'Umstellen',
    tw_countervalue: 'Gegenwert: {v} — als Kauf verbuchen',
    tw_save_changes: 'Änderungen speichern',
    tw_locked: 'Gesperrt',
    tw_copy: 'Kopieren',
    tw_fee_detected_reduced: 'Erkannte Gebühr: {amt} — bereits von der erhaltenen Menge abgezogen.',
    tw_fee_detected_increased: 'Erkannte Gebühr: {amt} — bereits zur abgegebenen Menge addiert.',
    tw_fee_detected_separate: 'Erkannte Gebühr: {amt} — als separate Gebühr-Transaktion erfasst.',

    // ── Transaktions-Zeilen (TxRow / TxCards / WalletDesktopTable) ─
    tx_derived_value_tip: 'Abgeleitet aus dem historischen Tages-Schlusspreis',
    tx_dust_badge: 'DUST',
    tx_dust_tip: 'Mikro-Eingang ohne Gegenwert — typisch für Address-Poisoning (Fremd-Adresse sendet wertlose Beträge, um in deiner Verlaufsliste aufzutauchen). Aus der Hauptliste ausgeblendet, im „Sonstige"-Tab einsehbar.',
    tx_asset: 'Asset',
    tx_source: 'Quelle',
    tx_none: 'Keine Transaktionen',
    tx_unknown: 'Unbekannt',
    tx_yesterday: 'Gestern',
    tx_transfer: 'Transfer',
    tx_internal_transfer: 'interner Transfer',
    tx_linked_manually: 'manuell verbunden',
    tx_fee_short: 'Geb.',
    tx_fee: 'Gebühr',
    tx_fee_in_spread: 'Gebühr im Spread',
    tx_fee_spread_tip: 'Bitpanda Consumer berechnet Gebühren über den Wechselkurs (Spread). Die Höhe ist über die API nicht ermittelbar — die Transaktion ist NICHT wirklich gebührenfrei.',
    tx_edit: 'Bearbeiten',
    tx_delete: 'Löschen',
    tx_unlink_transfer: 'Transfer trennen',
    tx_unlink_confirm: 'Verbindung aufheben? Beide Buchungen erscheinen wieder einzeln.',
    tx_cancel: 'Abbrechen',
    tx_unlink_confirm_yes: 'Ja, trennen',
    tx_inflow: 'Eingang',
    tx_outflow: 'Ausgang',
    tx_external_wallet: 'Externe Wallet',
    tx_own_wallet: 'Eigene Wallet',
    tx_wallet_suffix: '{name} Wallet',
    tx_counterpart: 'Gegenstück: {date}',
    tx_no_counterpart: 'Kein Gegenstück gefunden',
    tx_suggested: 'Empfohlen · {score} %',
    tx_onchain: 'on-chain',
    tx_sent_from: 'Gesendet von',
    tx_received_on: 'Empfangen auf',
    tx_from: 'Von',
    tx_to: 'An',
    tx_own_wallet_suffix: 'eigene Wallet',
    tx_external_short: 'Externe Wallet',
    tx_hl_transferred: 'transferiert',
    tx_hl_sent: 'gesendet',
    tx_hl_received: 'empfangen',
    tx_funding_fee: 'Gebühr',
    tx_liquidation: 'Liquidation',
    tx_futures_pnl: 'Futures PnL',
    tx_consumed: 'verbraucht',
    tx_gained: 'gewonnen',

    // ── CommandPalette ────────────────────────────────────────────
    cmd_group_pages: 'Seiten',
    cmd_group_actions: 'Aktionen',
    cmd_group_coins: 'Coins',
    cmd_placeholder: 'Springe zu Seite, Coin oder Aktion …',
    cmd_no_results: 'Keine Treffer.',
    cmd_open_alerts: 'Alerts öffnen',
    cmd_light_mode: 'Light-Mode einschalten',
    cmd_dark_mode: 'Dark-Mode einschalten',
    cmd_lang_en: 'Sprache: Englisch',
    cmd_lang_de: 'Sprache: Deutsch',

    // ── ImportReviewScreen ────────────────────────────────────────
    imp_title: 'Import prüfen',
    imp_unknownExchange: 'Unbekannte Börse',
    imp_transactions: 'Transaktionen',
    imp_transactions_checked: 'Transaktionen geprüft',
    imp_ready_short: 'Bereit zum Import',
    imp_aiConfidence: 'KI-Konfidenz',
    imp_confAuto: 'Auto-Import möglich',
    imp_confReview: 'Bitte prüfen',
    imp_confManual: 'Manuell überprüfen',
    imp_needsAttention_one: '{n} Transaktion braucht kurz deine Aufmerksamkeit',
    imp_needsAttention_other: '{n} Transaktionen brauchen kurz deine Aufmerksamkeit',
    imp_readyToImport: '{n} Transaktionen bereit zum Import',
    imp_recognized_clean: 'Alle {n} sauber erkannt',
    imp_recognized_some: '{ok} sauber erkannt · {n} zum Prüfen',
    imp_datacheck_pointer_one: '1 Punkt später im Datencheck klären',
    imp_datacheck_pointer_other: '{n} Punkte später im Datencheck klären',
    imp_chain_match_title: 'Stimmt mit der Blockchain überein',
    imp_chain_match_body: 'Dein berechneter Bestand entspricht exakt dem, was gerade auf der Adresse liegt — nichts fehlt, nichts doppelt.',
    imp_chain_balance: 'Bestand',
    imp_chain_mismatch_title: 'Bestand weicht leicht ab',
    imp_chain_mismatch_body: 'Der berechnete Bestand weicht von dem ab, was auf der Adresse liegt. Wahrscheinlich fehlen ein paar ältere Transaktionen.',
    imp_chain_computed: 'Berechnet',
    imp_chain_onchain: 'Auf der Adresse',
    imp_chain_mismatch_hint: 'Im Datencheck ansehen — löst sich, sobald die fehlenden Transaktionen ergänzt sind',
    // Erstkontakt „Verbinde deine erste Quelle" (ConnectFirstSource)
    cfs_title: 'Hol dein Portfolio rein, {name}.',
    cfs_title_noname: 'Hol dein Portfolio rein.',
    cfs_sub: 'Verbinde eine Quelle — wir gleichen sie direkt mit der Blockchain ab. Du siehst sofort, ob alles vollständig erfasst ist.',
    cfs_exchange_title: 'Börse verbinden',
    cfs_exchange_sub: 'Read-only-Schlüssel · automatisches Tracking',
    cfs_trust_exchange: 'wird mit der Börse abgeglichen',
    cfs_wallet_title: 'Wallet-Adresse',
    cfs_wallet_sub: 'BTC · ETH · SOL · XRP · ADA · XLM — per Adresse oder xpub',
    cfs_trust_chain: 'wird mit der Blockchain abgeglichen',
    cfs_csv_title: 'CSV hochladen',
    cfs_csv_sub: 'Exchange-Export (Binance, Kraken, Coinbase …)',
    cfs_manual_title: 'Manuell erfassen',
    cfs_manual_sub: 'Käufe, Verkäufe & Transfers von Hand',
    cfs_direct: 'Direkt verbinden',
    cfs_privacy: 'Read-only · Schlüssel verschlüsselt · keine Daten-Verkäufe',
    cfs_skip: 'Überspringen',
    imp_clickToEdit: 'Klicken zum Bearbeiten',
    imp_remove: 'Entfernen',
    imp_importing: 'Importiert…',
    imp_importApproved: '{n} Genehmigte importieren',
    imp_replaceAndImport: 'Alte ersetzen & {n} importieren',
    imp_importOk: '{n} OK importieren',
    imp_importAll: 'Alle {n} importieren',
    imp_staleTitle: 'Wird aktualisiert',
    imp_staleBody: 'Diese {n} {exchange}-Transaktionen ersetzen einen früheren Import und werden mit der aktuellen Berechnung neu erstellt — dein Bestand bleibt korrekt, nichts geht verloren.',
    imp_conflictTitle: 'Bereits vorhanden',
    imp_conflictBody_one: '{n} dieser Transaktion ist schon in deinem Portfolio und wird automatisch übersprungen — kein Doppelimport.',
    imp_conflictBody_other: '{n} dieser Transaktionen sind schon in deinem Portfolio und werden automatisch übersprungen — kein Doppelimport.',
    imp_moonpayTitle: '{n} MoonPay-Käufe → Ledger Wallet werden zusammengeführt',
    imp_moonpayBody: 'Diese Ledger-Eingänge sind die On-Chain-Lieferung deiner MoonPay-Käufe. Statt zwei Einträgen pro Kauf bekommst du einen kombinierten: Kaufpreis aus MoonPay, On-Chain-Hash und Wallet-Info aus Ledger.',
    imp_swapMergeTitle: '{n} Swap-Lieferung(en) werden zusammengeführt',
    imp_swapMergeBody: 'Diese On-Chain-Eingänge sind die Lieferung eines Tauschs, den du schon erfasst hast. Sie werden mit dem Tausch zusammengeführt statt doppelt gebucht.',
    imp_willMerge: 'Zusammengeführt',
    imp_reviewedOf: '{n} von {total} geprüft',
    imp_filterAll: 'Alle',
    imp_cat_merged: 'Zusammengeführt',
    imp_cat_existing: 'Bereits vorhanden',
    imp_showMore: '+ {n} weitere anzeigen',
    imp_emptyCategory: 'Keine Transaktionen in dieser Kategorie',
    imp_lowConfTitle: 'Niedrige KI-Konfidenz',
    imp_lowConfBody: 'Bitte prüfe die Transaktionen sorgfältig. Fehlerhafte Einträge werden nicht importiert.',
    // Automatischer Import-Audit (auditImport) — interne Konsistenz-Checks ohne Soll-Eingabe
    imp_audit_nondeterministic_title: 'Berechnung nicht stabil',
    imp_audit_nondeterministic_body: 'Der Bestand von {coins} hängt von der Reihenfolge der Transaktionen ab — das ist ein Berechnungsfehler, nicht deine Schuld. Bitte noch nicht speichern und uns diesen Import melden.',
    imp_willImport: 'Wird importiert',
    imp_alreadyExistsSkipped: 'Bereits vorhanden · übersprungen',
    imp_withErrorSkipped: 'Mit Fehler · übersprungen',
    imp_importAllNoErrors: 'Alle ohne Fehler importieren ({n})',

    // ── AlertWizard ───────────────────────────────────────────────
    aw_type_price_above_sub: 'Wenn der Coin eine Schwelle überschreitet.',
    aw_type_price_below_sub: 'Wenn der Coin unter eine Schwelle fällt.',
    aw_type_pct_change: '% Bewegung 24 h',
    aw_type_pct_change_sub: 'Wenn sich der Coin um X % bewegt.',
    aw_type_holding_period_sub: '1-Jahres-Frist deiner Position rückt näher.',
    aw_type_position_value: 'Positions-Wert',
    aw_type_position_value_sub: 'Wert deiner Coin-Position erreicht eine Schwelle.',
    aw_type_portfolio_value: 'Portfolio-Wert',
    aw_type_portfolio_value_sub: 'Dein Gesamtportfolio erreicht eine Schwelle.',
    aw_title_push_l1: 'Push',
    aw_title_push_l2: 'aktivieren',
    aw_title_coin_l1: 'Coin',
    aw_title_coin_l2: 'wählen',
    aw_title_type_l1: 'Alert',
    aw_title_type_l2: 'wählen',
    aw_title_threshold_l1: 'Schwelle',
    aw_title_threshold_l2: 'setzen',
    aw_title_review: 'Übersicht',
    aw_sub_push: 'Wir senden ausschließlich Push-Mitteilungen für Alerts, die du selbst angelegt hast. Keine Werbung. Jederzeit deaktivierbar.',
    aw_sub_coin: 'Ein Coin aus deinem Portfolio oder ein anderer.',
    aw_sub_type: 'Wann sollen wir dich benachrichtigen?',
    aw_sub_threshold_coin: 'Schwelle für {coin}.',
    aw_sub_threshold: 'Bei welcher Schwelle soll ausgelöst werden?',
    aw_sub_review: 'Letzter Blick, bevor wir den Alert anlegen.',
    aw_err_enable_failed: 'Aktivierung fehlgeschlagen.',
    aw_err_create_failed: 'Anlegen fehlgeschlagen.',
    aw_ios_title: 'Auf dem iPhone',
    aw_ios_hint_pre: 'Push funktioniert in Safari nur, wenn du red. zum ',
    aw_ios_hint_home: 'Home-Bildschirm',
    aw_ios_hint_post: ' hinzufügst und von dort öffnest.',
    aw_enable_push: 'Push aktivieren',
    aw_enable_later: 'Später aktivieren',
    aw_privacy_pre: 'Details in der',
    aw_privacy_link: 'Datenschutzerklärung',
    aw_privacy_post: '.',
    aw_from_portfolio: 'Aus deinem Portfolio',
    aw_other_coin: 'Anderer Coin',
    aw_coin_input_ph: 'CoinGecko-ID, z. B. bitcoin',
    aw_choose: 'Wählen',
    aw_unit_day: 'Tag',
    aw_unit_days: 'Tage',
    aw_caps_lead_time: 'Vorwarnzeit',
    aw_caps_portfolio_threshold: 'Portfolio-Schwelle',
    aw_caps_move_24h: 'Bewegung in 24 h',
    aw_caps_threshold_up: 'Schwelle nach oben',
    aw_caps_threshold_down: 'Schwelle nach unten',
    aw_current_price: 'Aktuell {price} {sym}',
    aw_n_day: '{n} Tag',
    aw_n_days: '{n} Tage',
    aw_portfolio: 'Portfolio',
    aw_verb_above: 'über',
    aw_verb_below: 'unter',
    aw_verb_reaches: 'erreicht',
    aw_review_holding_lead: 'Erreicht die',
    aw_review_holding_connector: '1-Jahres-Frist — Vorwarnung',
    aw_review_portfolio_lead: 'Erreicht',
    aw_review_portfolio_connector: 'einen Wert von',
    aw_review_move_lead: 'Bewegt sich ',
    aw_review_move_lead_pct: 'Bewegt sich um',
    aw_review_at_least: 'mindestens',
    aw_recurring: 'Wiederkehrend',
    aw_recurring_on: 'Mindestens 24 h Pause zwischen Triggers.',
    aw_recurring_off: 'Wird nur einmal ausgelöst, dann deaktiviert.',
    aw_create_alert: 'Alert anlegen',

    // ── Onboarding / Login ────────────────────────────────────────
    auth_welcome_title: 'Herzlich willkommen,',
    auth_welcome_sub: 'red. ist dein persönlicher Krypto-Begleiter.',
    auth_welcome_privacy: 'Privat, verschlüsselt, nur in deinem Konto sichtbar.',
    auth_lets_go: 'Los geht\'s',
    auth_name_title: 'Wie heißt du?',
    auth_name_sub: 'Dein Name erscheint in der App und auf exportierten Übersichts-Dokumenten.',
    auth_name_placeholder: 'Vorname oder Pseudonym',
    auth_name_hint: 'Wird nur für deine eigenen Exports (PDF / Excel) verwendet. Keine Weitergabe an Dritte. Pseudonym ist okay.',
    auth_country_title: 'In welchem Land lebst du?',
    auth_country_sub: 'Bestimmt, welche Funktionen für dich relevant sind.',
    auth_country_de_sub: 'FIFO · Haltefrist 1 Jahr',
    auth_country_at_sub: 'Gleitender Durchschnitt',
    auth_hero_sub: 'Dein gesamtes Krypto-Portfolio. Live. Read-only, nicht verwahrt, ohne Datenverkauf.',
    auth_continue_google: 'Mit Google anmelden',
    auth_continue_apple: 'Mit Apple anmelden',
    auth_continue_email: 'Mit E-Mail anmelden',
    auth_or: 'oder',
    auth_no_account: 'Noch kein Konto?',
    auth_register: 'Registrieren',
    auth_login_title: 'Anmelden',
    auth_login_loading: 'Anmelden…',
    auth_email: 'E-Mail',
    auth_password: 'Passwort',
    auth_password_min: 'Passwort (min. 6 Zeichen)',
    auth_forgot_password: 'Passwort vergessen?',
    auth_register_title: 'Konto erstellen',
    auth_register_loading: 'Konto erstellen…',
    auth_reset_title: 'Passwort zurücksetzen',
    auth_reset_sub: 'Wir senden dir einen Link zum Zurücksetzen.',
    auth_reset_sent: 'Link gesendet! Schau in dein Postfach.',
    auth_reset_cta: 'Link senden',
    auth_reset_loading: 'Senden…',
    auth_back_to_login: 'Zurück zum Login',
    auth_privacy_note: 'Deine Portfolio-Daten sind privat — nur in deinem Konto sichtbar.',
    auth_consent_pre: 'Mit dem Anmelden akzeptierst du unsere',
    auth_consent_and: 'und',
    auth_err_user_not_found: 'Kein Konto mit dieser E-Mail gefunden.',
    auth_err_wrong_password: 'Falsches Passwort.',
    auth_err_invalid_credential: 'E-Mail oder Passwort falsch.',
    auth_err_email_in_use: 'Diese E-Mail ist bereits registriert.',
    auth_err_weak_password: 'Passwort muss mindestens 6 Zeichen haben.',
    auth_err_invalid_email: 'Ungültige E-Mail-Adresse.',
    auth_err_too_many_requests: 'Zu viele Versuche. Bitte später erneut versuchen.',
    auth_err_enter_email: 'Bitte E-Mail eingeben.',
    auth_err_generic: 'Fehler beim Anmelden. Bitte erneut versuchen.',

    // ── red/ SmartCheck / Timeline / Analyse ──────────────────────
    red_sc_available_after_period: 'deines {sym}-Bestands sind nach Ablauf der 1‑Jahres‑Frist verfügbar.',
    red_sc_today: 'heute',
    red_sc_next_tranche_in: 'Nächste Tranche frei in',
    red_sc_days: 'Tagen',
    // ── red/ Freigabe-Agenda (Haltefrist-Überblick, DE) ───────────
    red_ag_all_coins: 'Alle Coins',
    red_ag_title: 'Freigaben',
    red_ag_sub: 'Wann jede Tranche die 1-Jahres-Frist überschreitet — über dein gesamtes Portfolio.',
    red_ag_hero_caption: 'deines Bestands sind frei verfügbar',
    red_ag_free_caption: 'frei · heute',
    red_ag_next_releases: 'Nächste Freigaben',
    red_ag_bucket_soon: 'Bald · nächste 90 Tage',
    red_ag_bucket_later_year: 'Später {year}',
    red_ag_bound_left: 'noch gebunden',
    red_ag_all_free: 'Alle Tranchen sind außerhalb der Frist.',
    red_ag_days_unit: 'Tage',
    red_ag_reminder: 'Bei Freigabe erinnern',
    red_ag_reminder_sub: 'Push, sobald eine Tranche fällt',
    red_ag_axis_toggle: 'Zeitachse ein-/ausklappen',
    // ── Datencheck (Vollständigkeit, Profil/Dashboard) ────────────
    dc_kicker: 'Datencheck',
    dc_title: 'Stimmt dein Bild?',
    dc_sub: 'Wir gleichen deine Bestände gegen verbundene Quellen ab und zeigen, was noch zu klären ist. Alles lokal aus deinen Daten.',
    dc_all_clear: 'Alles abgeglichen',
    dc_to_clarify: 'Punkte zu klären',
    dc_rest_clear: 'der Rest deines Bilds ist abgeglichen',
    dc_sources_live: 'Quellen verbunden',
    dc_sect_open: 'Zu klären',
    dc_open_transfer: '{n} Transfers ohne Gegenpart',
    dc_open_transfer_one: '1 Transfer ohne Gegenpart',
    dc_open_transfer_hint: 'eigener Transfer oder echter Zukauf?',
    dc_external: '{n} externe Empfänge',
    dc_external_one: '1 externer Empfang',
    dc_external_hint: 'Geschenk, eigene Wallet oder woanders gekauft?',
    dc_cta_assign: 'Zuordnen',
    dc_no_basis: '{n} Tranchen ohne Kaufpreis',
    dc_no_basis_one: '1 Tranche ohne Kaufpreis',
    dc_no_basis_from: 'vom',
    dc_no_basis_hint: 'ohne Basis kein verlässlicher Wert',
    dc_cta_complete: 'Ergänzen',
    dc_sect_sources: 'Deine Quellen',
    dc_tx_count: '{n} Transaktionen',
    dc_src_api: 'API verbunden',
    dc_src_chain: 'Adresse beobachtet · on-chain',
    dc_src_csv: 'CSV-Import',
    dc_src_manual: 'Manuell erfasst',
    dc_status_connected: 'verbunden',
    dc_status_imported: 'importiert',
    dc_status_manual: 'manuell',
    dc_dust: '{n} mögliche Scam-Dust-Einträge ausgeblendet',
    dc_note: 'Andere Tools rechnen still falsch, wenn ein Transfer oder Kaufpreis fehlt. red. macht die Lücken sichtbar — laut statt still.',
    dc_open: 'Datencheck',
    dc_fix_title: 'Zu klären',
    dc_fix_sub: 'Diese {n} Transaktionen brauchen noch Klärung. Tippe eine an, um den Gegenpart zuzuordnen oder den Kaufpreis zu ergänzen.',
    dc_fix_empty: 'Alles geklärt — keine offenen Transaktionen.',
    dc_fix_sect_transfer: 'Ohne Gegenpart',
    dc_fix_sect_external: 'Extern empfangen — Quelle zuordnen',
    dc_fix_sect_basis: 'Ohne Kaufpreis',
    dc_fix_hint: 'Fehlender Gegenpart = der Eingang ist noch keiner Auszahlung zugeordnet. Ohne Kaufpreis behandelt der Bericht die Tranche konservativ — echte Käufe lohnt sich zu ergänzen.',
    red_tl_no_open_tranches: 'Keine offenen FIFO-Tranchen für {sym}.',
    red_tl_hero_l1: 'deines {sym}-Bestands',
    red_tl_hero_l2: 'über der 1-Jahres-Frist',
    red_tl_next_pre: 'In',
    red_tl_next_days: '{days} Tagen',
    red_tl_next_mid: 'überschreiten weitere',
    red_tl_next_post: 'die Frist.',
    red_tl_today: 'Heute',
    red_tl_bound: 'gebunden',
    red_aa_close: 'Schließen',
    red_aa_avg_buy: 'Ø Einkauf',
    red_aa_per: 'pro {sym}',
    red_aa_buys_one: '{n} Kauf',
    red_aa_buys_many: '{n} Käufe',
    red_aa_hero_up: 'Im Plus gegenüber deinen Einzahlungen',
    red_aa_hero_down: 'Im Minus gegenüber deinen Einzahlungen',
    red_aa_hero_even: 'Break-Even',
    red_aa_return: '% Rendite',
    red_aa_cashflow: 'Cash-Flow',
    red_aa_deposited: 'Eingezahlt',
    red_aa_deposited_sub: 'Fiat-Käufe + Stablecoin-Brücken',
    red_aa_withdrawn: 'Bereits rausgenommen',
    red_aa_sells_one: '{n} Verkauf',
    red_aa_sells_many: '{n} Verkäufe',
    red_aa_no_sells: 'Noch keine Verkäufe',
    red_aa_holding_today: 'Bestand heute',
    red_aa_total_perf: 'Gesamt-Performance:',
    red_aa_summary_pre: 'Du hast bisher',
    red_aa_summary_invested: ' in {name} investiert.',
    red_aa_summary_of_which: 'Davon hast du bereits',
    red_aa_summary_withdrawn: ' wieder herausgenommen.',
    red_aa_summary_no_sells: 'Bisher wurden noch keine Verkäufe getätigt.',
    red_aa_summary_remaining: 'Dein verbleibender Bestand ({amount} {sym}) ist heute',
    red_aa_summary_worth: ' wert.',
    red_aa_disclaimer: 'Berechnungen basieren auf erfassten EUR-Werten. Stablecoin-Swaps werden via Pegging (1:1) bewertet. Marktpreise: CoinGecko · red. ist kein Steuerberater.',

    // ── red/ Markt-Widgets (MarketIndices / LiveTicker / PromoCard) ─
    wid_market_live: 'Markt · Live',
    wid_loading: 'LÄDT',
    wid_close: 'Schließen',
    wid_live: 'LIVE',
    wid_ago_min: 'vor {min} min',
    wid_source: 'Daten · {src}',
    wid_history_30d: 'Verlauf · 30 Tage',
    wid_30_days: '30 TAGE',
    wid_30_days_inline: '30 Tage',
    wid_yesterday: 'Gestern',
    wid_last_week: 'Vor einer Woche',
    wid_last_month: 'Vor einem Monat',
    wid_neutral: 'Neutral',
    wid_neutral_s: 'Neutral',
    wid_fg_title: 'Angst & Gier',
    wid_fg_extreme_fear: 'Extreme Angst',
    wid_fg_extreme_fear_s: 'Extr. Angst',
    wid_fg_fear: 'Angst',
    wid_fg_fear_s: 'Angst',
    wid_fg_greed: 'Gier',
    wid_fg_greed_s: 'Gier',
    wid_fg_extreme_greed: 'Extreme Gier',
    wid_fg_extreme_greed_s: 'Extr. Gier',
    wid_scale_fear_lo: '0 · Angst',
    wid_scale_greed_hi: 'Gier · 100',
    wid_fg_info_title: 'Was misst der Index?',
    wid_fg_info_pre: 'Stimmung am Krypto-Markt von ',
    wid_fg_info_mid: ' (extreme Angst) bis ',
    wid_fg_info_post: ' (extreme Gier) — aus Volatilität, Volumen, Social-Media, Dominanz und Trends. Niedrige Werte deuten oft Kaufchancen an, hohe Werte Vorsicht.',
    wid_btcd_title: 'Bitcoin · Dominanz',
    wid_btcd_weak: 'BTC schwach',
    wid_btcd_alt_phase_s: 'Alt-Phase',
    wid_btcd_strong: 'BTC stark',
    wid_btcd_strong_s: 'BTC stark',
    wid_btcd_dominant: 'BTC dominant',
    wid_btcd_dominant_s: 'Dominant',
    wid_stablecoins: 'Stablecoins',
    wid_rest_market: 'Rest des Marktes',
    wid_total_mcap: 'Marktkap. gesamt',
    wid_vol_24h: 'Vol. 24h',
    wid_btcd_info_title: 'Was bedeutet BTC-Dominanz?',
    wid_btcd_info_body: 'Anteil von Bitcoin an der Gesamt-Marktkapitalisierung aller Kryptowährungen. Steigt sie, fließt Kapital aus Altcoins zurück in BTC (Risk-Off). Fällt sie, gewinnen Altcoins relativ — oft Vorbote einer Altseason.',
    wid_total_title: 'Krypto · Gesamtmarkt',
    wid_total_tile: 'Gesamtmarkt',
    wid_total_alt_mcap: 'Alt-Markt · ohne BTC',
    wid_total_assets: 'Aktive Coins',
    wid_total_composition: 'Marktgewicht',
    wid_total_history: 'Verlauf',
    wid_no_history: 'Kein Verlauf verfügbar',
    wid_r_7d: '7T',
    wid_r_30d: '30T',
    wid_r_90d: '90T',
    wid_r_1y: '1J',
    wid_total_info_title: 'Was zeigt die Gesamt-Marktkapitalisierung?',
    wid_total_info_body: 'Der Gesamtwert aller Kryptowährungen zusammen — Kurs × Umlaufmenge, über den ganzen Markt summiert. Sie zeigt, wie viel Kapital insgesamt in Krypto steckt. Der Alt-Markt rechnet Bitcoin heraus und macht die Bewegung der übrigen Coins sichtbar.',
    wid_unit_trillion: 'Bio.',
    wid_unit_billion: 'Mrd.',
    wid_unit_million: 'Mio.',
    wid_alt_title: 'Altcoin · Season Index',
    wid_alt_btc_season: 'Bitcoin Season',
    wid_alt_btc_season_s: 'BTC-Saison',
    wid_alt_btc_pref: 'BTC bevorzugt',
    wid_alt_mixed: 'Gemischt',
    wid_alt_mixed_s: 'Gemischt',
    wid_alt_altseason: 'Altseason',
    wid_alt_altseason_s: 'Altseason',
    wid_alt_beat_btc: '{out}/{total} schlagen BTC',
    wid_scale_btc_season_lo: '0 · Bitcoin-Saison',
    wid_scale_altseason_hi: 'Altseason · 100',
    wid_top_outperformers: 'Top-Aufsteiger · 30 Tage',
    wid_btc_30d: 'Bitcoin · 30 Tage',
    wid_alt_outperform_label: 'Altcoins schlagen BTC',
    wid_alt_info_title: 'Wie wird berechnet?',
    wid_alt_info_pre: 'Anteil der Top-50-Coins (ohne Stablecoins und gewrappte Token), die Bitcoin über die letzten ',
    wid_alt_info_mid: ' performance-mäßig geschlagen haben. ',
    wid_alt_info_mid2: ' gilt als Altseason, ',
    wid_alt_info_post: ' als Bitcoin Season.',
    wid_alt_source: 'Daten · CoinGecko · Methode nach BlockchainCenter',
    // Calm-Redesign der Markt-Indizes (einheitlicher Bau)
    wid_btcd_title_calm: 'Bitcoin-Dominanz',
    wid_alt_title_calm: 'Altseason',
    wid_fg_sub: 'Stimmung am Krypto-Markt',
    wid_btcd_sub: 'Anteil von Bitcoin am Gesamtmarkt',
    wid_alt_sub: 'Schlagen Altcoins gerade Bitcoin?',
    wid_total_sub: 'Wert aller Kryptowährungen zusammen',
    wid_scale_btcd_lo: '0 · Altcoins',
    wid_scale_btcd_hi: 'Nur Bitcoin · 100',
    wid_vs_yesterday: 'ggü. gestern',
    wid_last_24h: 'in den letzten 24 Std.',
    wid_plan: 'Plan',
    wid_activate: 'Aktivieren',
    wid_vip_tagline: 'Lebenslang · Concierge-Support',
    wid_promo_price: '€49/Jahr',

    // ── Modals/Sheets (ExportSheet / LimitGate / Support / Bell) ──
    mod_export_eyebrow_asset: 'Analyse',
    mod_export_eyebrow_report: 'Bericht',
    mod_export_asset_title: '{name} exportieren',
    mod_export_report_title: 'Bericht exportieren',
    mod_export_sub_asset: 'Wähle das Format. Beide enthalten Übersicht, Veräußerungsübersicht (je Anschaffung) und alle Transaktionen.',
    mod_export_sub_year: 'Wähle das Format. Beide enthalten Veräußerungsübersicht je Anschaffung, Allokation und alle Transaktionen.',
    mod_export_report_year: 'Berichtsjahr',
    mod_export_pdf_sub: 'Druckfertig & gebrandet',
    mod_export_xlsx_sub: 'Frei filter- & sortierbar',
    mod_export_unlock_pre: 'Freischalten mit',
    mod_export_unlock_report: 'Report',
    mod_export_unlock_asset_pre: 'Asset-Export mit',
    mod_export_footer_ready: 'Wird serverseitig erstellt und automatisch heruntergeladen.',
    mod_per_year_suffix: '/Jahr',
    mod_limit_unlimited: 'unbegrenzt',
    mod_limit_title_exceed: 'Import würde Limit überschreiten',
    mod_limit_title_block: 'Limit für {year} erreicht',
    mod_limit_sub_exceed: 'Du willst {n} TX importieren, aber nur {fit} passen noch in dein {year}er Konto.',
    mod_limit_sub_block: 'Dein Tarif erlaubt {limit} TX pro Jahr. Für {year} hast du bereits {count} eingetragen.',
    mod_limit_year_label: 'Jahr {year}',
    mod_limit_recommendation: 'Empfehlung',
    mod_limit_features: '{limit} TX pro Jahr · KI-Import · Excel & PDF Reports · API-Anbindungen',
    mod_limit_view_plans: 'Tarife ansehen →',
    mod_limit_later: 'Später',
    mod_limit_reassure: 'Bestehende Transaktionen bleiben erhalten. Du kannst weiterhin alles ansehen.',
    mod_support_title: 'Support kontaktieren',
    mod_support_sub: 'Wo tritt das Problem auf? Wir erstellen dazu eine Diagnose-Datei mit deinen Transaktionen, die du an die E-Mail anhängst — keine Passwörter oder Schlüssel.',
    mod_support_footer_pre: 'Öffnet dein E-Mail-Programm an',
    mod_support_app: 'App',
    mod_support_app_sub: 'iOS & Android',
    mod_support_pc: 'PC',
    mod_support_pc_sub: 'Web im Browser',
    mod_support_mail_subject: 'Support-Anfrage',
    mod_support_mail_desc: 'Beschreibung des Problems:',
    mod_support_mail_platform: 'Plattform',
    mod_support_mail_platform_app: 'App (Mobile)',
    mod_support_mail_platform_web: 'Web (PC)',
    mod_support_mail_tx: 'Transaktionen',
    mod_support_mail_origin: 'Origin',
    mod_support_mail_version: 'Version',
    mod_support_mail_plan: 'Plan',
    mod_support_mail_attach: 'WICHTIG: Bitte die soeben heruntergeladene Datei „{file}" an diese E-Mail anhängen — sie hilft uns, dein Problem nachzuvollziehen (enthält keine Passwörter oder Schlüssel).',
    mod_bell_title: 'Benachrichtigungen',
    mod_bell_just_now: 'gerade eben',
    mod_bell_min_ago: 'vor {n} Min',
    mod_bell_hr_ago: 'vor {n} Std',
    mod_bell_day_ago: 'vor {n} Tag',
    mod_bell_days_ago: 'vor {n} Tagen',
    mod_bell_empty_title: 'Noch keine Alerts',
    mod_bell_empty_sub: 'Sobald ein Alert auslöst, erscheint er hier.',
    mod_bell_fired: 'Alert ausgelöst',
    mod_bell_manage_all: 'Alle Alerts verwalten ›',
    mod_bell_clear_expired: 'Abgelaufene löschen',

    // ── Connect-Flows (Solana / API / Privacy / LinkTransfer) ─────
    con_phantom_title: 'Phantom Wallet verbinden',
    con_how_it_works: 'So funktioniert\'s',
    con_phantom_how_body: 'Verbinde Phantom direkt oder füge deine Solana-Adresse manuell ein. Wir holen deine kompletten On-Chain-Transaktionen und klassifizieren Swaps (Jupiter/Raydium), Transfers und Spam-Airdrops automatisch.',
    con_phantom_opening: 'Phantom öffnet…',
    con_phantom_connect: 'Mit Phantom verbinden',
    con_phantom_open_app: 'In Phantom-App öffnen',
    con_phantom_install: 'Phantom installieren',
    con_phantom_connected: 'Phantom verbunden',
    con_disconnect: 'Trennen',
    con_or_manual: 'ODER MANUELL',
    con_sol_address: 'Solana-Adresse',
    con_sol_addr_base58: 'Adresse muss 32-44 Base58-Zeichen lang sein.',
    con_label_optional: 'Label (optional)',
    con_label_placeholder: 'z.B. Phantom, Backpack, Ledger-SOL',
    con_label_hint: 'Wird als Exchange-Name angezeigt — nützlich wenn du mehrere Solana-Wallets hast.',
    con_error: 'Fehler',
    con_status: 'Status',
    con_import: 'Importieren',
    con_sol_loading_txs: 'Lade Solana-Transaktionen…',
    con_sol_readonly_note: 'Hinweis: Nur Lesezugriff — wir können keine Transaktionen ausführen, nur deine On-Chain-Historie auslesen. Deine Adresse ist öffentlich auf der Solana-Blockchain einsehbar und wird nicht bei uns gespeichert.',
    con_phantom_not_found: 'Phantom nicht gefunden. Installiere die Browser-Extension von phantom.app und lade die Seite neu.',
    con_phantom_no_address: 'Phantom hat keine gültige Adresse geliefert.',
    con_phantom_rejected: 'Verbindung in Phantom abgelehnt.',
    con_phantom_failed: 'Phantom-Verbindung fehlgeschlagen.',
    con_sol_addr_invalid_paste: 'Bitte eine gültige Solana-Adresse einfügen (32-44 Zeichen).',
    con_error_status: 'Fehler {status}',
    con_sol_no_txs: 'Keine Transaktionen gefunden für {addr}…',
    con_sol_parsed: '{parsed} von {fetched} Transaktionen erkannt — Review wird geöffnet.',
    con_sol_sync_failed: 'Solana-Sync fehlgeschlagen.',
    // ── UTXO-Wallet-Import (Bitcoin & Co. via Blockchair) ──
    tw_method_utxo_title: 'Wallet-Adresse',
    tw_method_utxo_sub: 'BTC, ETH, Solana, XRP & mehr — per Adresse oder xpub',
    cwc_title: 'Bitcoin & Wallets verbinden',
    cwc_how_body: 'Wähle die Chain und füge eine Adresse oder einen xpub/zpub ein. Wir holen die komplette On-Chain-Historie (Ein-/Auszahlungen + Gebühren) automatisch. Ein xpub deckt dein ganzes Wallet ab.',
    cwc_chain: 'Blockchain',
    cwc_value_label: 'Adresse oder xpub',
    cwc_value_label_addr: 'Adresse',
    cwc_value_placeholder: 'z.B. bc1q… oder xpub6C…',
    cwc_value_placeholder_addr: 'Öffentliche Adresse deines Wallets',
    cwc_value_hint_addr: 'Die öffentliche Adresse deines Wallets. Account-Chains wie Stellar haben kein xpub — eine Adresse = das ganze Konto.',
    cwc_value_hint_ada: 'Cardano: Gib deine Stake-Adresse (stake1…) ein — das deckt dein GANZES Wallet ab. Eine einzelne addr1… erfasst nur einen Teil.',
    cwc_value_hint_evm: 'EVM-Adresse (0x…) — sie gilt über alle EVM-Netze. Wähle oben das Netzwerk, auf dem du gehandelt hast (dieselbe Adresse kann auf mehreren Netzen aktiv sein).',
    cwc_skipped: '{count} unbekannte Token übersprungen ({names}). Importiert werden nur eindeutig identifizierbare Coins — kein Spam. Fehlt dir ein echter Coin? Trag ihn manuell nach.',
    cwc_wallet_name: 'Wallet',
    cwc_wallet_name_ph: 'z.B. Ledger',
    cwc_wallet_name_hint: 'Bestimmt, wie diese Quelle in den Transaktionen heißt (z.B. „MoonPay → Ledger").',
    cwc_wallet_select: 'Wallet wählen…',
    cwc_pick_title: 'Wallet wählen',
    cwc_pick_sub: 'Eine gespeicherte Wallet verwenden oder eine Marke wählen.',
    cwc_pick_brand: 'Marke',
    cwc_my_wallets: 'Meine Wallets',
    cwc_new_wallet: 'Neue Wallet anlegen',
    cwc_pick_search: 'Suchen…',
    cwc_pick_use: 'Verwenden:',
    wr_title: 'Meine Wallets',
    wr_card_sub: 'Adressen hinterlegen — Importe werden automatisch richtig benannt.',
    wr_how_title: 'Adressen einmal hinterlegen',
    wr_how_body: 'Speichere deine eigenen Wallet-Adressen mit Namen (z.B. „Ledger", „MetaMask"). Beim Import einer bekannten Adresse wird sie automatisch richtig benannt — kein „→ ETH", kein manuelles Nachbenennen. Nur deine Daten, Adressen sind on-chain ohnehin öffentlich.',
    wr_name: 'Wallet-Name',
    wr_name_ph: 'z.B. Ledger, MetaMask',
    wr_chain: 'Chain',
    wr_address: 'Adresse',
    wr_address_ph: 'Öffentliche Adresse einfügen',
    wr_address_ph_utxo: 'Adresse oder xpub einfügen',
    wr_add: 'Wallet speichern',
    wr_saving: 'Speichere…',
    wr_saved: 'Gespeichert ({n})',
    wr_empty: 'Noch keine Wallets hinterlegt.',
    wr_invalid: 'Bitte Name und eine gültige Adresse eingeben.',
    wr_failed: 'Speichern fehlgeschlagen.',
    wr_known: 'Bekannte Wallet',
    wr_pick: 'Aus „Meine Wallets" wählen',
    wr_add_cta: 'Wallet hinzufügen',
    wr_step_wallet: 'Welche Wallet?',
    wr_step_wallet_sub: 'Wähle deine Wallet — Hardware oder Software.',
    wr_step_chain: 'Welche Chain?',
    wr_step_chain_sub: 'Auf welchem Netzwerk liegt deine {wallet}-Adresse?',
    wr_step_address: 'Adresse einfügen',
    wr_hw: 'Hardware-Wallets',
    wr_sw: 'Software-Wallets',
    wr_other_sec: 'Andere',
    wr_other_name_ph: 'Name deiner Wallet',
    wr_next: 'Weiter',
    wr_addr_help: 'Die öffentliche Empfangsadresse deiner Wallet — einfach aus der Wallet kopieren.',
    wr_addr_help_xpub: 'Fortgeschritten: Ein xpub/zpub erfasst dein ganzes Hardware-Wallet auf einmal (optional, statt einer Einzeladresse).',
    wr_watch: 'Automatisch überwachen',
    wr_watch_sub: 'Täglich auf neue Bewegungen prüfen',
    wr_own: 'Eigene Wallet',
    wr_own_sub: 'Transfers hierher gelten nicht als Verkauf',
    wr_review_title: 'Zu prüfen',
    wr_review_hint: 'Automatisch erkannt — kurz bestätigen, dann ist es sauber drin.',
    wr_review_open: 'Alle prüfen ({n})',
    wr_review_src: 'Wallet-Überwachung',
    wr_auto_imported: '{n} automatisch übernommen (Transfer zwischen deinen Wallets)',
    cwc_preview_cta: 'Wallet prüfen',
    cwc_preview_title: 'Vorschau — vor dem Import prüfen',
    cwc_preview_body: '{count} Transaktionen werden importiert ({coins}).',
    cwc_preview_confirm: '{count} importieren',
    cwc_preview_pricing: 'Preise laden… ({done}/{total})',
    cwc_preview_cancel: 'Abbrechen',
    cwc_overlap_title: 'Mögliche Dopplungen',
    cwc_overlap_body: 'Diese Coins hast du teils schon im Bestand ({coins}). Wenn du sie bereits per CSV oder Börse erfasst hast, entstehen beim Import Dopplungen — danach kurz in den Transaktionen prüfen.',
    cwc_xpub_hint: 'Adresse = nur diese eine Adresse. xpub/zpub (vom Hardware-Wallet, z.B. Ledger) = das komplette Wallet mit allen Adressen — empfohlen.',
    cwc_address: 'Adresse',
    cwc_loading: 'Lade {name}-Transaktionen…',
    cwc_readonly_note: 'Nur Lesezugriff. Deine Adresse/dein xpub ist öffentlich auf der Blockchain einsehbar und wird nicht bei uns gespeichert — die Anfrage läuft nur über unser Backend an den Blockchain-Datenanbieter.',
    cwc_value_invalid: 'Bitte eine gültige Adresse oder einen xpub einfügen.',
    cwc_no_txs: 'Keine Transaktionen gefunden für {addr}…',
    cwc_parsed: '{parsed} Transaktionen erkannt ({kind}) — Review wird geöffnet.',
    cwc_failed: 'Wallet-Import fehlgeschlagen.',
    cwc_backfill_title: 'Fehlende Preise nachladen',
    cwc_backfill_body: '{n} importierte Transaktionen ohne EUR-Wert. Historische Tagespreise via CoinGecko nachziehen.',
    cwc_backfill_cta: 'Preise nachladen',
    cwc_backfill_running: 'Lade Preise… {done}/{total}',
    cwc_backfill_done: '{patched} von {total} TX mit Preis nachgerüstet.',
    cwc_backfill_toast: '{n} Preise nachgerüstet',
    con_moonpay_title: 'MoonPay-Doppelbuchungen aufräumen',
    con_moonpay_body: '{n} Wallet-Eingänge stimmen mit einem MoonPay-Kauf überein. Der Wallet-Eintrag wird entfernt, der MoonPay-Kauf bekommt die Wallet-Info zusätzlich.',
    con_moonpay_cleanup_btn: '{n} Paare bereinigen',
    con_moonpay_cleaned: '{n} MoonPay-Wallet-Paare bereinigt.',
    con_processing: 'Verarbeite…',
    con_backfill_title: 'Fehlende Preise nachladen',
    con_backfill_body: '{n} bestehende Transaktionen ohne Wert gefunden. Historische Tagespreise werden via CoinGecko nachgezogen.',
    con_backfill_btn: 'Preise für {n} TX nachladen',
    con_backfill_loading: 'Lade Preise… {done}/{total}',
    con_backfill_done: '{patched} von {total} TX mit Preis nachgerüstet.',
    con_backfill_hint_prefix: 'Hinweis: {hints}.',
    con_backfill_hint_too_old: '{n} Tagespreis-Abfragen liegen über 365 Tage zurück — der kostenlose CoinGecko-Demo-Tier liefert dafür keine historischen Preise (Pro-Key nötig oder Wert manuell ergänzen)',
    con_backfill_hint_no_key: 'kein CoinGecko-API-Key in der Server-Konfiguration hinterlegt',
    con_backfill_hint_rate_limit: 'CoinGecko-Rate-Limit erreicht — später erneut versuchen',
    con_backfill_hint_not_found: '{n} ohne verfügbaren Tagespreis',
    con_backfill_toast_ok: '✓ {n} TX bepreist',
    con_backfill_toast_none: 'Keine Preise nachgerüstet — siehe Hinweis',
    con_exchange_api: 'Exchange-API',
    con_exchange_api_sub: 'Read-Only-Keys verbinden — automatisches Tracking deiner Transaktionen.',
    con_premium_feature: 'Premium-Feature',
    con_api_sync_premium: 'API-Sync ist Teil des Premium-Tiers. Du kannst Verbindungen anlegen, aber für den Sync benötigst du Premium.',
    con_view_plans: 'Pläne ansehen',
    con_load_connections_failed: 'Konnte Verbindungen nicht laden.',
    con_sync_warning: 'Hinweis: {warnings}',
    con_sync_success: 'Sync erfolgreich: {count} neue Transaktionen ({trades} Trades, {ledger} Ledger, {skipped} übersprungen)',
    con_sync_failed: 'Sync fehlgeschlagen.',
    con_delete_confirm: '"{label}" wirklich entfernen?\nDeine bisher importierten Transaktionen bleiben erhalten.',
    con_connection_removed: 'Verbindung entfernt.',
    con_delete_failed: 'Löschen fehlgeschlagen.',
    con_connection_saved: 'Verbindung gespeichert.',
    con_loading_connections: 'Lade Verbindungen…',
    con_no_connections: 'Noch keine Verbindungen',
    con_no_connections_sub: 'Verbinde deine erste Börse, um Transaktionen automatisch zu importieren.',
    con_connect_new_exchange: '+ Neue Börse verbinden',
    con_never: 'Noch nie',
    con_last_sync: 'Letzter Sync: {time}',
    con_syncing: 'Syncing…',
    con_sync_now: 'Jetzt synchronisieren',
    con_remove: 'Entfernen',
    con_choose_exchange: 'Börse wählen',
    con_soon: 'Bald',
    con_choose_other: 'Andere wählen',
    con_create_readonly_key: 'Read-Only-Key erstellen',
    con_readonly_important_pre: 'Wichtig: Erstelle einen ',
    con_readonly_key_strong: 'Read-Only-Key',
    con_readonly_important_post: ' (kein Trading, keine Auszahlung).',
    con_scope_note_binance: 'Hinweis: Bei Binance werden Ein-/Auszahlungen, Fiat-Käufe und Spot-Trades übernommen. Convert, Earn & Staking-Erträge sind noch nicht dabei — der Saldo-Abgleich nach dem Sync zeigt dir etwaige Lücken.',
    con_reconcile_ok: 'Bestände stimmen mit der Börse überein ✓ ({matches} Coins geprüft)',
    con_reconcile_mismatch: 'Achtung: {count} Coin(s) weichen vom Börsen-Bestand ab — evtl. fehlen Transaktionen. Bitte ggf. per CSV ergänzen: {detail}',
    con_reconcile_partial: 'Hinweis: Saldo-Abgleich für diese Börse noch nicht verfügbar (Spot-Trades folgen).',
    con_open_guide: 'Anleitung öffnen ↗',
    con_designation_optional: 'Bezeichnung (optional)',
    con_designation_placeholder: 'z. B. "Mein {exchange}-Account"',
    con_api_key: 'API-Key',
    con_api_key_placeholder: 'API-Key hier einfügen',
    con_api_secret: 'API-Secret',
    con_passphrase: 'Passphrase',
    con_passphrase_placeholder: 'Passphrase aus dem Exchange-Setup',
    con_connection_ok: 'Verbindung OK',
    con_connection_failed: 'Verbindung fehlgeschlagen',
    con_credentials_work: 'Die Credentials funktionieren. Du kannst die Verbindung jetzt speichern.',
    con_testing: 'Teste…',
    con_test: 'Testen',
    con_saving: 'Speichere…',
    con_save_failed: 'Konnte nicht speichern.',
    con_privacy_sub: 'Welche Daten verarbeitet werden — und wie du Kontrolle behältst.',
    con_priv_ai_title: 'KI-Analyse',
    con_priv_ai_body_pre: 'Für die automatische Erkennung von CSV-, Excel-, PDF- oder Bilddateien wird der Inhalt der Datei an ',
    con_priv_ai_body_post: ' übertragen (Auftragsverarbeitung auf Basis EU-Standardvertragsklauseln). Laut Google-API-Terms wird der Inhalt nicht zum Modelltraining verwendet und nicht mit anderen Usern geteilt.',
    con_priv_local_title: 'Was lokal bleibt',
    con_priv_local_body: 'Bekannte Börsenformate (Binance, Bitpanda, Kraken, Coinbase u.a.) werden zuerst von einem lokalen Parser verarbeitet. In diesen Fällen verlässt deine Datei den Browser nicht — die KI kommt nur ins Spiel, wenn der lokale Parser ein Format nicht erkennt.',
    con_priv_store_title: 'Was wir speichern',
    con_priv_store_body_pre: 'In deinem privaten Bereich (',
    con_priv_store_body_post: '): deine bestätigten Transaktionen, der Importverlauf und Auto-Reviews. In einer technischen Schema-Datenbank speichern wir nur die Spalten-Struktur bekannter Formate — keine Transaktionsinhalte.',
    con_priv_retention_title: 'Speicherdauer',
    con_priv_retention_body: 'Importprotokolle werden nach 24 Monaten automatisch gelöscht. Deine Transaktionsdaten bleiben so lange erhalten, bis du sie selbst löschst oder dein Konto schließt.',
    con_priv_rights_title: 'Deine Rechte (Art. 15–22 DSGVO)',
    con_priv_rights_body: 'Du kannst jederzeit Auskunft, Berichtigung, Löschung oder Datenübertragbarkeit verlangen. Bei Kontolöschung werden alle dir zuordenbaren Daten entfernt.',
    con_priv_consent_loading: 'Lade Einwilligungsstatus…',
    con_priv_consent_active: 'KI-Einwilligung aktiv',
    con_priv_consent_active_body: 'Erteilt am {date}. Du kannst die Einwilligung jederzeit zurückziehen.',
    con_priv_consent_none: 'Keine KI-Einwilligung erteilt',
    con_priv_consent_none_body: 'Aktuell läuft nur der lokale Parser. Beim nächsten Upload bekommst du die Frage automatisch.',
    con_priv_revoking: 'Widerrufe…',
    con_priv_revoke: 'KI-Einwilligung widerrufen',
    con_transfer_confirm_title: 'Transfer bestätigen',
    con_transfer_confirm_sub: 'Prüfe die Buchungen, bevor du sie verbindest.',
    con_source: 'Quelle',
    con_target: 'Ziel',
    con_amount_sent: 'Betrag gesendet',
    con_amount_received: 'Betrag empfangen',
    con_difference: 'Differenz',
    con_network_fee: 'Netzwerkgebühr',
    con_time_difference: 'Zeitdifferenz',
    con_currency: 'Währung',
    con_time_under_min: 'unter 1 Min.',
    con_time_min: '{n} Min.',
    con_time_hrs: '{n} Std.',
    con_time_days: '{n} Tage',
    con_quality_strong: 'Sehr gute Übereinstimmung',
    con_quality_medium: 'Mögliche Übereinstimmung',
    con_quality_weak: 'Schwache Übereinstimmung',
    con_linking: 'Wird verbunden…',
    con_link_as_transfer: 'Als Transfer verbinden',

    // ── Misc (App / UpdateBanner / SwipeAction / Settings-CSV) ────
    misc_update_title: 'Neue Version verfügbar',
    misc_update_body: 'Kurz neu laden, damit alle Berechnungen aktuell sind.',
    misc_update_reload: 'Neu laden',
    misc_hide: 'Ausblenden',
    misc_csv_import_title: 'Datei importieren',
    misc_csv_import_sub: 'CSV, Excel, PDF oder Screenshot — KI erkennt das Format automatisch und importiert alle Transaktionen.',
    misc_csv_analyzing: 'KI analysiert CSV…',
    misc_csv_analyzing_sub: 'Das kann einige Sekunden dauern',
    misc_csv_drop_title: 'Datei hier ablegen',
    misc_csv_drop_sub: 'CSV, Excel, PDF, Bild — oder klicken zum Auswählen',
    misc_csv_err_no_tx: 'KI konnte keine Transaktionen erkennen. Bitte überprüfe das Dateiformat.',
    misc_csv_err_connection: 'Verbindungsfehler. Bitte erneut versuchen.',
    misc_onboard_welcome: 'Willkommen',
    misc_onboard_headline_1: 'Erste Transaktion',
    misc_onboard_headline_2: 'erfassen.',
    misc_onboard_body_desktop_pre: 'Klicke auf ',
    misc_onboard_body_desktop_post: ' (＋) links in der Navigationsleiste, um Kauf, Verkauf oder CSV-Import zu starten.',
    misc_onboard_body_mobile_pre: 'Tippe auf das ',
    misc_onboard_body_mobile_post: ' unten in der Mitte, um Kauf, Verkauf oder CSV-Import zu starten.',
    misc_onboard_cta: 'Los geht\'s',
  },
  en: {
    dashboard: 'Dashboard', portfolio: 'Portfolio', markets: 'Markets',
    transactions: 'Transactions', reports: 'Reports', alerts: 'Alerts',
    settings: 'Settings', profile: 'Profile',
    premium: 'Premium', vip: 'VIP', free: 'Free',

    hello: 'Good day', total_portfolio: 'Total portfolio', invested: 'Invested',
    unrealized: 'Unrealized', realized: 'Realized', positions: 'Positions',
    change_24h: '24h change', allocation: 'Allocation', your_assets: 'Your assets',
    recent_activity: 'Recent activity', view_all: 'View all',
    top_mover: 'Top mover', since_entry: 'since entry',

    all_transactions: 'All transactions', import: 'Import',
    import_d: 'Upload your exchange exports (Binance, Kraken, Coinbase…)',
    add_tx: 'Add transaction', manual: 'Manual', csv_import: 'CSV import',
    api_import: 'API / Exchange', photo_import: 'Photo / Screenshot',
    manual_d: 'Enter buys, sells and transfers by hand.',
    csv_d: 'Upload your exchange exports (Binance, Kraken, Coinbase…).',
    api_d: 'Connect read-only API keys for automatic tracking.',
    photo_d: 'Import via photo or screenshot — AI detects values automatically.',
    popular_exchanges: 'Popular exchanges',

    market_overview: 'Market overview',
    buy_x: 'Buy {x}', price: 'Price', change_7d: '7d',
    market_cap: 'Market cap', volume: '24h volume',
    sort_by: 'Sort', search_markets: 'Search coins…',
    live_coingecko: 'Live · CoinGecko', n_coins: '{n} coins',

    tax_year: 'Report year', fifo_calc: 'FIFO', taxable_events: 'Events',
    tax_obligation: 'Indicative (26%)', of_which_free: 'Of which outside holding period',
    tax: 'Info', kept: 'Kept', pdf_report: 'Report · PDF',
    report_year: 'Fiscal year', sales_count: 'Sales',
    pdf_history: 'Report · PDF', total_pnl: 'Profit / Loss',
    tax_disclaimer: 'Note: Red. is not a tax tool. All figures are informational only and do not constitute tax advice.',

    add_alert: 'Add alert', price_above: 'Price above', price_below: 'Price below',

    coin: 'Coin', amount: 'Amount', value: 'Value', type: 'Type', date: 'Date',
    buy: 'Buy', sell: 'Sell', swap: 'Swap', deposit: 'Deposit', withdrawal: 'Withdrawal',
    bought: 'bought', sold: 'sold', swapped: 'swapped', received: 'received', sent: 'sent',
    verified: 'On-chain verified',
    cancel: 'Cancel', save: 'Save', delete: 'Delete', confirm: 'Confirm',
    back: 'Back', next: 'Next', close: 'Close', today: 'Today',

    sponsored: 'Sponsored',
    ad_placeholder_eyebrow: 'AD SLOT', ad_placeholder_type: 'Reserved',
    ad_placeholder_title: 'Your brand could live here.',
    ad_placeholder_sub: 'Premium dashboard ad slot — reach out for partnerships.',
    ad_placeholder_cta: 'Learn more',
    ad_placeholder2_eyebrow: 'AD SLOT', ad_placeholder2_type: 'Available',
    ad_placeholder2_title: 'Reach that matters.',
    ad_placeholder2_sub: 'Connect with a crypto-savvy audience inside the portfolio workflow.',
    ad_placeholder2_cta: 'Contact us',

    overview: 'Overview', tax_status: 'Holding-period status', action: 'Action',
    holdings: 'Holdings', avg_price: 'Avg. price', current_price: 'Current price',
    pnl: 'Profit / Loss', tx_history: 'Transactions', buy_more: 'Buy more',
    course: 'Price history',

    smart_check: 'Smart Check', holding_period: 'Holding period',
    tax_free: 'Outside period', taxable: 'Within period',
    holding_d: 'Info: In DE, private crypto disposals are typically treated differently after the 1-year holding period (§ 23 EStG). Not tax advice — consult a tax professional.',
    next_milestone: 'Next milestone', days_remaining: 'days remaining',
    full_tax_free: 'Fully outside holding period', lots: 'FIFO lots', since: 'since',
    tax_free_in_x_days: 'In {days} days, another {amount} {sym} will be outside the 1-year period.',
    pct_of_x_is_free: '{pct} % of your {sym} holdings are outside the 1-year period.',
    free_check: 'outside period', days_short: 'd',

    appearance: 'Appearance', dark_mode: 'Dark mode', language: 'Language', currency: 'Currency',
    security_2fa: 'Security · 2FA', connected_exchanges: 'Connected exchanges',
    plan_status: 'Plan', plan_free: 'Free',
    upgrade_premium: 'Upgrade · €4.99 (one-time)', redeem_code: 'Redeem code',
    delete_data: 'Delete all data', delete_confirm: 'Really delete all data irrevocably?',
    name: 'Name',

    tagline: 'Your crypto portfolio, at a glance.',
    brand_footer: 'red.app · v1.0',

    plans: 'Plans',
    transaction: 'Transaction',
    sign_out: 'Sign out',
    member_since: 'Member since',
    light_mode: 'Light mode',
    search_placeholder: 'Coins, transactions, commands …',
    quick_search: 'Quick search',
    support: 'Support',
    collapse_sidebar: 'Collapse',
    expand_sidebar: 'Expand',
    connect: 'Connect',
    upgrade: 'Upgrade',
    per_year: '/ year',
    premium_promo_features: 'Reports · AI import · Exchange APIs',
    account: 'Account',
    your_data_gdpr: 'Your data · GDPR',
    privacy: 'Privacy',
    privacy_gdpr: 'Privacy & GDPR',
    eu_hosting: 'EU hosting',
    theme: 'Theme',
    private_mode: 'Private mode',
    private_visible: 'Visible',
    private_hidden: 'Hidden',
    connected_sources: 'Connected sources',
    no_sources_connected: 'No sources connected yet. Tap “Connect” to get started.',
    connected_since: 'Connected since {date}',
    api_read_only: 'API · read-only',
    account_security: 'Account security',
    security_login: '2FA & sign-in security',
    coming_soon: 'Coming soon',
    manage_alerts: 'Manage alerts',
    redeem_vip_code: 'Redeem VIP code',
    export_data_json: 'Export data (JSON)',
    exporting: 'Exporting…',
    delete_all_txs: 'Delete all transactions',
    delete_account_full: 'Delete account completely',
    irreversible: 'irreversible',
    usage: 'Usage',
    in_premium_5000: 'Unlimited — no TX cap',
    sources: 'Sources',
    enter_name: 'Enter name',
    profile_settings_title: 'Profile & settings.',
    new_exchange_connect: '+ Connect new exchange',
    loading: 'Loading…',
    no_api_connected: 'No API connected yet.',
    select_language: 'Language',
    select_currency: 'Currency',
    feedback_give: 'Give feedback',
    feedback_mail_subject: 'Beta feedback',
    feedback_mail_body: 'Hi! Thanks for testing the beta. Tell me briefly:\n\n• What do you like?\n• What\'s missing / what would you like?\n• What was confusing or didn\'t work?\n\nEvery detail helps – thank you!',
    tour_marker: 'Tour',
    tour_skip: 'Skip',
    tour_next: 'Next',
    tour_done: 'Let\'s go',
    tour_welcome_eyebrow: 'Welcome',
    tour_welcome_title: 'Glad you\'re here.',
    tour_welcome_body: 'Quick tour – in 30 seconds I\'ll show you the essentials.',
    tour_overview_eyebrow: 'Overview',
    tour_overview_title: 'All your crypto, in one place.',
    tour_overview_body: 'The dashboard shows your total value and how it develops – across every exchange and wallet.',
    tour_transactions_eyebrow: 'Transactions',
    tour_transactions_title: 'Every move, cleanly sorted.',
    tour_transactions_body: 'See all your buys, sells and transfers here – merged automatically.',
    tour_add_eyebrow: 'Add',
    tour_add_title: 'Exchange, wallet or manual.',
    tour_add_body: 'Tap + to import via CSV, exchange API or wallet address – or enter transactions yourself.',
    tour_reports_eyebrow: 'Report',
    tour_reports_title: 'Proof, when you need it.',
    tour_reports_body: 'Need clean proof for the tax office? Generate it here as PDF or Excel.',
    tour_privacy_eyebrow: 'Private & free',
    tour_privacy_title: 'Read-only. Private. Free.',
    tour_privacy_body: 'We only read – your keys stay yours. No tracking, full scope free. Let\'s go!',
    redeem: 'Redeem',
    copy: 'Copy',
    delete_all_data_q: 'Delete all data?',
    delete_account_q: 'Delete account completely?',
    creating: 'Creating…',

    // ── Dashboard ─────────────────────────────────────────────────
    dash_gain_unrealized: 'Gain (unrealized)',
    dash_vs_prefix: "That's",
    dash_vs_suffix: ' than you put in.',
    dash_more: 'more',
    dash_less: 'less',
    dash_your_wealth: 'Your wealth',
    dash_your_holdings: 'Your holdings',
    dash_stat_invested: 'invested',
    dash_stat_today: 'today',
    dash_stat_values: 'assets',
    dash_stat_sources: 'exchanges & wallets',
    dash_safety_strong: 'Only you can see this.',
    dash_safety_rest: "Encrypted, read-only — we can't touch your money.",
    ad_label: 'Ad',
    ad_slot_title: 'Your brand could be here.',
    ad_slot_sub: 'Premium spot in the dashboard.',
    ad_slot2_title: 'Reach crypto users.',
    ad_slot2_sub: 'Right in the portfolio workflow.',
    greet_morning: 'Good morning',
    greet_day: 'Good afternoon',
    greet_evening: 'Good evening',
    dash_of_limit: 'of {limit}',
    dash_total_portfolio_full: 'Total portfolio',
    dash_hero_headline_1: 'Your wealth,',
    dash_hero_headline_2: 'in motion.',
    dash_today: 'TODAY',
    dash_gain: 'Gain',
    dash_history: 'History',
    dash_no_data: 'No data yet',
    dash_history_loading: 'Calculating history…',
    dash_history_empty: 'Once historical prices are available, your actual portfolio value over time will appear here.',
    dash_history_empty_title: 'Your history is forming',
    dash_position_one: 'position',
    dash_invested_short: 'invested',
    dash_alloc_collapse: 'Hide allocation',
    dash_alloc_expand: 'Show allocation',
    dash_asset: 'Asset',
    dash_return: 'Return',
    dash_n_hidden: '{n} hidden',
    dash_show: 'Show',
    dash_hide: 'Hide',
    dash_edit: 'Edit',
    dash_done: 'Done',
    dash_active_alerts: 'Active alerts',
    dash_all_arrow: 'All ›',
    dash_no_active_alerts: 'No active alerts yet.',
    dash_create_now: 'Create now ›',
    dash_holding_period: 'Holding period',
    dash_activate: 'Activate',
    dash_pause: 'Pause',
    dash_n_more: '+{n} more',
    dash_assets: 'Assets',
    dash_external_wallet: 'External wallet',
    dash_derived_price: 'Derived from the historical daily closing price',
    dash_empty_coins_1: 'No coins yet.',
    dash_empty_coins_2: 'Tap + to get started.',
    dash_no_transactions: 'No transactions yet',

    // ── WalletScreen ──────────────────────────────────────────────
    wal_tab_sent: 'Sent',
    wal_tab_received: 'Received',
    wal_tab_transfers: 'Transfers',
    wal_tab_inflows: 'Staking/Airdrop',
    wal_tab_staking: 'Staking',
    wal_tab_futures: 'Futures',
    wal_tab_fiat: 'Cash in/out €',
    wal_tab_other: 'Other',
    wal_irreversible: 'Irreversible',
    wal_delete_single_title: 'Delete transaction?',
    wal_delete_bulk_title_one: 'Delete {count} transaction?',
    wal_delete_bulk_title_many: 'Delete {count} transactions?',
    wal_delete_single_desc: 'This transaction will be permanently deleted. Holdings and FIFO calculations will be recalculated.',
    wal_delete_desc_selection_pre: 'The ',
    wal_delete_desc_selection_post: ' selected transactions will be permanently deleted.',
    wal_delete_desc_all_pre: 'All ',
    wal_delete_desc_all_count: '{count}',
    wal_delete_desc_all_post: ' loaded entries will be deleted — including trading fees, fiat movements and NFT entries that are normally hidden from the list.',
    wal_delete_desc_filtered_pre: 'All transactions matching ',
    wal_delete_desc_filtered_post: ' will be permanently deleted.',
    wal_delete_desc_filtered_generic: 'All filtered transactions will be permanently deleted.',
    wal_deleting: 'Deleting…',
    wal_delete_final: 'Delete permanently',
    wal_back_to_dashboard: 'Back to dashboard',
    wal_close_filter: 'Close filter',
    wal_eyebrow_history: 'Complete history',
    wal_title_dot: 'Transactions.',
    wal_loaded: 'loaded',
    wal_exchanges_wallets: 'Exchanges & wallets',
    wal_open_transfers: 'TX check',
    wal_open_transfers_review: 'TX check · review',
    wal_open_transfers_filtered: 'Open transfers · filtered',
    wal_sub_calm: 'Automatically merged from your exchanges and wallets.',
    wal_filtered: 'filtered',
    wal_review: 'review',
    wal_sources: 'Sources',
    wal_type: 'type',
    wal_types: 'types',
    wal_source_ai: 'AI',
    wal_click_cards: 'Click cards',
    wal_n_selected: '{count} selected',
    wal_reset_selection: 'Reset selection',
    wal_exit_mode: 'Exit mode',
    wal_delete_count: 'Delete ({count})',
    wal_empty_title: 'No transactions',
    wal_empty_desc: 'Add your first purchase.',
    wal_sort: 'Sort',
    wal_delete_individually: 'Delete individually',
    wal_delete_filtered: 'Delete filtered',
    wal_delete_all: 'Delete all',
    wal_search_placeholder: 'Coin, exchange, date, hash …',
    wal_actions: 'Actions',
    wal_open_transfer_one: 'point to clear up',
    wal_open_transfer_many: 'points to clear up',
    wal_review_now: 'Review now',
    wal_link_transfers: 'Link transfers',
    wal_link_hint_first: 'Select the first entry',
    wal_link_hint_second: 'Select the matching counter-entry',
    wal_link_hint_ready: 'Ready to link',
    wal_tap_cards: 'Tap cards to mark them',
    wal_close_selection_mode: 'Close selection mode',
    wal_tx_count_one: '{count} transaction',
    wal_tx_count_many: '{count} transactions',
    wal_no_results: 'No results',
    wal_no_results_desc: 'Adjust the filter or reset it.',
    wal_manually_sorted: 'manually sorted',
    wal_edit_order: 'Edit order',
    wal_tap_cards_short: 'Tap cards',
    wal_n_of_2_selected: '{count}/2 selected',
    wal_n_open_one: '{count} open',
    wal_n_open_many: '{count} open',
    wal_done: 'Done',
    wal_connect: 'Link',

    // ── AssetDetailScreen ─────────────────────────────────────────
    asset_edit: 'Edit',
    asset_no_tx: 'No transactions for {sym} yet',
    asset_dust_hidden: '{n} micro-deposits (dust) hidden',
    asset_chart_load_failed: 'Chart could not be loaded',
    asset_retry: 'Try again',
    asset_chart_loading: 'Loading price history…',
    asset_analyse: 'Analysis',
    asset_analyse_subtitle: 'Performance & cash flow in detail',
    asset_hint_label: 'Note',
    asset_exchange_hint: 'Some purchases / deposits are missing the exchange field. Add it to enable wallet-specific FIFO.',
    asset_alert: 'Alert',
    asset_export_action: 'Export',
    asset_report_generating: 'Generating report…',
    asset_alarm: 'Alert',
    asset_export_label: 'Export',
    asset_no_position: 'You don\'t hold {sym} yet. Add a buy manually or import a CSV.',
    asset_export_failed: 'Export failed.',
    asset_position: 'Position',
    asset_chg_pre: 'Today',
    asset_chg_more: 'more',
    asset_chg_less: 'less',
    asset_chg_post: 'than yesterday',

    // ── MarketsScreen ─────────────────────────────────────────────
    mkt_sort_mcap: 'Market cap',
    mkt_col_asset: 'Asset',
    mkt_col_24h: '24h',
    mkt_col_7d: '7d',
    mkt_col_mcap: 'Mkt cap',
    mkt_favorites: 'Favorites',
    mkt_fav_add: 'Add to favorites',
    mkt_fav_remove: 'Remove from favorites',
    mkt_live: 'Live',
    mkt_unit_trillion: 'T',
    mkt_unit_billion: 'B',
    mkt_unit_million: 'M',
    mkt_empty_favorites: 'No favorites yet — tap the star on a coin.',
    mkt_empty_coins: 'No coins found.',

    // ── TaxScreen / Reports ───────────────────────────────────────
    tax_unlock_premium: 'Unlock Premium',
    tax_unlock_sub: 'One-time purchase · API, Excel & PDF · 500+ transactions',
    tax_feat_api: 'API connection',
    tax_feat_api_sub: 'Connect your exchange directly',
    tax_feat_export: 'Excel & PDF export',
    tax_feat_export_sub: 'Print-ready & structured',
    tax_feat_txs: '500+ transactions',
    tax_feat_txs_sub: 'Unlimited entries',
    tax_total_price: 'Total price',
    tax_no_vat: '(no VAT — small-business scheme § 19 UStG)',
    tax_waiver_text: 'I expressly request that provision of the digital content begin before the withdrawal period expires. I acknowledge that I lose my right of withdrawal once execution begins (§ 356 (5) BGB). Our',
    tax_waiver_terms: 'terms',
    tax_waiver_and: 'and the',
    tax_waiver_privacy: 'privacy policy apply',
    tax_order_paid: 'Order with obligation to pay',
    tax_cancel: 'Cancel',
    tax_no_acquisition: 'No acquisition found — cost basis unknown.',
    tax_in_holding: 'Within holding period',
    tax_over_year: 'Past 1-year period',
    tax_swap: 'Swap',
    tax_loss: 'Loss',
    tax_proceeds: 'Proceeds',
    tax_acquisition: 'Acquisition',
    tax_fee: 'Fee',
    tax_result: 'Result',
    tax_fifo_match: 'FIFO match · acquisitions',
    tax_warn_cost_basis: 'Cost basis unknown — result cannot be computed.',
    tax_warn_incomplete: 'FIFO could not match all portions.',
    tax_warn_fallback: 'Cross-wallet match due to incomplete data.',
    tax_event: 'event',
    tax_events: 'Events',
    tax_paid_out: 'Paid out',
    tax_result_fifo: 'Result · FIFO',
    tax_today_live: 'Today · live',
    tax_in_holdings: '{amount} held',
    tax_no_remaining: 'No remaining balance',
    tax_holding_status: 'Holding-period status',
    tax_choose_coin: 'Choose coin',
    tax_generating: 'Generating…',
    tax_export_report: 'Export report',
    tax_open_detail: 'Asset details',
    tax_sc_title: 'When does your position reach the 1-year period?',
    tax_sc_sub: 'Each FIFO lot as its own bar. Today line, countdown in days, green tick on the cut-off date.',
    tax_pct_of_holdings: 'of your {coin} holdings',
    tax_over_1y_period: 'past the 1-year period',
    tax_market_value: 'Market value',
    tax_current_live_price: 'current live price',
    tax_in_prefix: 'In',
    tax_n_days: '{n} days',
    tax_next_tranche_mid: 'another',
    tax_next_tranche_suffix: 'passes the period.',
    tax_all_tranches_free: 'All lots are past the 1-year period.',
    tax_free_legend: 'free',
    tax_bound_legend: 'bound',
    tax_decl_no: 'Declaration № {n}',
    tax_decl_official: 'Official · red.app',
    tax_decl_page: 'Page 01 · 01',
    tax_decl_subject: 'Subject',
    tax_decl_facts: 'Facts',
    tax_sc_decl_headline: 'We\'re not tax advisors — and we don\'t pretend to be.',
    tax_sc_decl_body: 'We don\'t produce filings for the tax office; we lack the licence for that. What we deliver: complete, cleanly prepared transaction histories with charts. That\'s usually enough for the tax office — or hand it to your tax advisor. Free from Premium.',
    tax_coin_search_ph: 'Search, e.g. BTC, ETH, SHIB…',
    tax_no_coin_found: 'No coin found.',
    tax_active: 'Active',
    tax_annual_report: 'Annual report',
    tax_export: 'Export',
    tax_realized_gain: 'Realized gain',
    tax_realized_loss: 'Realized loss',
    tax_fifo_over_sales: 'From all sales and swaps, in purchase order (FIFO).',
    tax_avg_over_sales: 'From all sales and swaps, using a moving average.',
    tax_method_long: 'a moving average',
    tax_event_in_year: 'transaction counted.',
    tax_events_in_year: 'transactions counted.',
    tax_realized_gain_fifo: 'Gain from sales · FIFO',
    tax_realized_loss_fifo: 'Loss from sales · FIFO',
    tax_realized_gain_average: 'Gain from sales · moving average',
    tax_realized_loss_average: 'Loss from sales · moving average',
    tax_cost_of_sold: 'Purchase cost of sold coins:',
    tax_loss_carry: 'Offsettable loss',
    tax_model_deduction_26: 'Indicative deduction (26%)',
    tax_model_deduction_275: 'Indicative deduction (27.5%)',
    tax_method_average: 'Avg cost',
    tax_model_deduction: 'Indicative deduction',
    tax_offsettable: 'Offsettable against future gains',
    tax_calc_26_flat: 'Non-binding example only',
    tax_calc_flat: 'Non-binding example only',
    tax_kept_share: 'You keep',
    tax_after_model_deduction: 'after the indicative deduction',
    tax_held_over_year: 'Held over 1 year',
    tax_held_over_year_sub: 'Holding period met — fully yours',
    tax_held_under_year: 'Held under 1 year',
    tax_held_under_year_gain_sub: 'Holding period not met — the indicative deduction applies here',
    tax_held_under_year_loss_sub: 'A loss — offsettable against future gains',
    tax_deduction_this_year: 'Indicative deduction this year',
    tax_you_keep: 'You keep',
    tax_you_keep_pct: '{pct}% of your result',
    tax_flow_title: 'How your result adds up',
    tax_flow_proceeds: 'Sale proceeds',
    tax_flow_cost: '− Purchase',
    tax_flow_result_gain: '= Gain',
    tax_flow_result_loss: '= Loss',
    tax_flow_note_gain: 'Most of what came back was simply your own money returning. Only the green part is real gain.',
    tax_flow_note_loss: 'You got back less than you originally invested.',
    tax_by_holding: 'By holding period',
    tax_keep_all: 'You don\'t need to set anything aside — the whole gain stays yours.',
    tax_keep_some: 'Set aside roughly {ded} — you keep {kept}.',
    tax_details_show: 'Show details',
    tax_details_hide: 'Hide details',
    tax_answer_keep_all_title: 'You keep all of it.',
    tax_answer_keep_all_sub: 'You don\'t need to set anything aside this year.',
    tax_answer_keep_some_title: 'Set aside roughly {ded}.',
    tax_answer_keep_some_sub: 'You keep the rest — {kept} stays with you.',
    tax_answer_loss_title: 'A loss on balance.',
    tax_answer_loss_sub: 'Offsettable against future gains.',
    tax_answer_loss_sub_at: 'Offsettable only within the same calendar year.',
    tax_total: 'Total',
    tax_balance_btn: 'View statement',
    tax_balance_title: 'Your statement {year}',
    tax_balance_intro: 'Exactly how your result adds up.',
    tax_bal_intro: 'Held over a year doesn\'t count, shorter does.',
    tax_bal_over: 'OVER 1 YEAR',
    tax_bal_under: 'UNDER 1 YEAR',
    tax_bal_sale: 'sale',
    tax_bal_sales: 'sales',
    tax_bal_result: 'Result',
    tax_dur_y: 'y',
    tax_dur_m: 'mo',
    tax_bal_at_intro: 'Legacy holdings (before 1 Mar 2021) stay free — newer ones count, with no holding period.',
    tax_bal_at_free: 'LEGACY',
    tax_bal_at_tax: 'NEW',
    tax_carryloss_note_at: 'A loss on balance — offsettable only within the same calendar year (no carryforward).',
    tax_at_alt_label: 'Legacy holdings · free',
    tax_at_alt_sub: 'pre-1 Mar 2021, held over 1 year — doesn\'t count',
    tax_at_gain_label: 'Gain · new holdings',
    tax_at_deduction: 'Indicative {pct}%',
    tax_at_remains: 'You keep',
    tax_at_keep_pct: 'you keep {pct}%',
    tax_at_setaside_pct: 'set aside {pct}%',
    tax_at_disclaimer: 'A loss offsets only within the same calendar year (no carryforward). Crypto-to-crypto swaps are neutral — not a realization.',
    tax_inline_disclaimer_long: 'Indicative model calculation of {pct}% on the realized gain — not an official assessment, not binding advice, no allowances, losses or special cases considered. For your specific situation, please ask your own tax advisor or the tax office.',
    tax_inline_disclaimer_short: 'Indicative {pct}% calculation — not an official assessment, not binding advice.',
    tax_calc_notes: 'Notes on the calculation',
    tax_split_title: 'Breakdown of your result',
    tax_relevant_event: 'transaction included',
    tax_relevant_events: 'transactions included',
    tax_turnover: 'Turnover',
    tax_realized: 'Gain / loss',
    tax_sold: 'sold',
    tax_swapped: 'swapped',
    tax_today: 'Today',
    tax_basis_incomplete: 'Basis incomplete',
    tax_decl_annual_report: 'Annual report · red.app',
    tax_rp_decl_headline: 'What you see here — and what you don\'t.',
    tax_rp_decl_body: 'A statement of your realized results for {year} based on {method}. Not an official assessment, not binding advice. Sufficient in most cases for the tax office or as a template for your tax advisor. Full export from Premium.',
    tax_export_failed: 'Export failed.',
    tax_empty_title: 'No transactions yet',
    tax_empty_line1: 'Add transactions to',
    tax_empty_line2: 'see your report.',
    tax_carryloss_note: 'A loss on balance — offsettable against future gains.',
    tax_your_coins: 'Your coins',
    tax_premium_hint: 'Full annual export from €19 (one-time) or Premium €49 / year',

    // ── PricingScreen ─────────────────────────────────────────────
    price_eyebrow: 'Pricing',
    price_title: 'Four ways, no trial nonsense.',
    price_subtitle: 'You get most of the benefits in the Free plan already — reports are a small add-on.',
    price_note_forever: 'forever',
    price_note_per_year_once: 'one-time',
    price_note_per_year_month: 'per year · €{month}/mo.',
    price_note_per_year: 'per year',
    price_feat_free_unlimited: 'Unlimited transactions',
    price_feat_free_track: 'Entry, tracking, overviews',
    price_feat_free_live: 'Live prices via CoinGecko',
    price_feat_free_import: 'Manual + CSV import',
    price_feat_free_reports_addon: 'Reports available as add-on (€{price} / year)',
    price_feat_report_excel_pdf: 'Excel + PDF report for one year',
    price_feat_report_all_tx: 'Up to 500 transactions / year',
    price_feat_report_charts: 'With charts for the tax office',
    price_feat_report_no_sub: 'No subscription — buy individually',
    price_feat_premium_5000tx: 'Reports up to 5,000 TX / year',
    price_feat_premium_ai_upload: 'Photo & CSV upload with AI',
    price_feat_premium_free_reports: 'Free Excel + PDF reports',
    price_feat_premium_per_coin: 'Reports per coin (with charts)',
    price_feat_premium_smart_check: 'Smart Check (holding period, DE)',
    price_feat_premium_exchange_apis: 'Exchange APIs (read-only)',
    price_feat_vip_all_premium: 'Everything in Premium',
    price_feat_vip_unlimited: 'Reports with no TX limit',
    price_feat_vip_priority: 'Priority support',
    price_feat_vip_early_access: 'Early access to new features',
    price_feat_vip_code: 'Unlockable via invite code',
    price_cta_free_start: 'Start for free',
    price_cta_report_buy: 'Buy report',
    price_cta_premium_unlock: 'Unlock Premium',
    price_cta_vip_become: 'Become VIP',
    price_cta_current_plan: 'Current plan',
    price_cta_already_bought: 'Already bought for {year}',
    price_cta_in_your_plan: 'Included in your plan',
    price_cta_in_vip: 'Included in VIP',
    price_activating: 'Activating…',
    price_report_kicker: 'One-time · no subscription',
    price_report_headline: 'Your proof for the tax office.',
    price_report_seal: 'red. verified',
    price_report_doc_title: 'ANNUAL REPORT',
    price_trust_gdpr: 'GDPR-compliant',
    price_trust_eu: 'Servers in the EU',
    price_trust_no_advice: 'Not tax advice',
    price_trust_bayern: 'Made in Bavaria',
    price_trust_cancel: 'No subscription, no auto-renewal',

    // ── AlertsScreen ──────────────────────────────────────────────
    alert_line_rises_above: '{coin} rises above',
    alert_line_falls_below: '{coin} falls below',
    alert_line_moves: '{coin} moves',
    alert_line_holding_period: '{coin} · 1-year period',
    alert_line_position_at: '{coin} position at',
    alert_line_portfolio_at: 'Portfolio at',
    alert_pause: 'Pause',
    alert_activate: 'Activate',
    alert_once: 'One-time',
    alert_recurring: 'Recurring',
    alert_last_triggered: 'last {date}',
    alert_created_at: 'created {date}',
    alert_delete_aria: 'Delete alert',
    alert_coin_search_placeholder: 'Search coin … e.g. Bitcoin, SOL, PEPE',
    alert_no_coin_found: 'No coin found.',
    alert_cond_price_above: 'Rises above',
    alert_cond_price_below: 'Falls below',
    alert_cond_pct_change: '± Move 24h (%)',
    alert_cond_holding_period: 'Holding period (1-year period)',
    alert_cond_position_value: 'Position value ({sym})',
    alert_cond_portfolio_value: 'Portfolio value ({sym})',
    alert_new_alert: 'New alert',
    alert_condition: 'Condition',
    alert_change: 'change',
    alert_value_warn_days: 'Lead time (days)',
    alert_value_percent: 'Percent (%)',
    alert_value_portfolio: 'Portfolio value ({sym})',
    alert_value_position: 'Position value ({sym})',
    alert_value_target_price: 'Target price ({sym})',
    alert_err_days_range: 'Please enter 1–365 days',
    alert_err_invalid_value: 'Please enter a valid value',
    alert_err_create_failed: 'Couldn\'t create alert. Please try again.',
    alert_current: 'Current:',
    alert_holding_hint: 'Heads-up before a {coin} lot reaches the 1-year period.',
    alert_created_ok: 'Alert created',
    alert_creating: 'Creating…',
    alert_create: 'Create alert',
    alert_confirm_delete: 'Really delete this alert?',
    alert_confirm_disable_push: 'Disable push notifications? You can re-enable them anytime.',
    alert_push_enable_failed: 'Activation failed. Please try again.',
    alert_empty_title: 'No alerts yet',
    alert_empty_hint_below: 'Create your first one below.',
    alert_empty_hint_right: 'Create your first one on the right.',
    alert_one_moment: 'One moment…',
    alert_push_disable: 'Disable push notifications',
    alert_activating: 'Activating…',
    alert_push_enable: 'Enable push notifications',
    alert_eyebrow: 'Price & holding period',
    alert_title_heading: 'Alerts.',
    alert_subtitle: 'We\'ll notify you when a price hits your threshold — or when a FIFO lot passes the 1-year period.',
    alert_banner_unsupported_title: 'Push not supported',
    alert_banner_unsupported_body: 'Your browser doesn\'t support push notifications. You can still create alerts — they\'ll be delivered once you open red. in a supported browser.',
    alert_banner_blocked_title: 'Notifications blocked',
    alert_banner_blocked_body: 'You\'ve blocked notifications for red. Enable them in your browser settings so alerts can reach you.',
    alert_banner_ios_title: 'iPhone tip',
    alert_banner_ios_body: 'In Safari tap Share → "Add to Home Screen" and open red. from there to enable push.',

    // ── ProfileScreen (Desktop + Mobile) ──────────────────────────
    prof_theme_dark: 'Dark',
    prof_theme_light: 'Light',
    prof_lang_de_name: 'German',
    prof_2fa_login_security: '2FA & login security',
    prof_beta: 'Beta',
    prof_program_suffix: 'Program',
    prof_beta_headline_pre: 'The most active testers get ',
    prof_beta_headline_accent: '1 year VIP',
    prof_beta_headline_post: ' for free.',
    prof_beta_sub: 'Reported a bug, submitted an idea, gave feedback — we see it.',
    prof_vip_code_desc: 'Enter your VIP code to unlock all features.',
    prof_owner_gift_code: 'Owner · gift a code',
    prof_vip_once_redeemable: '1 year VIP · redeemable once',
    prof_create_vip_code: 'Create new VIP code',
    prof_your_data_gdpr_paren: 'Your data (GDPR)',
    prof_delete_account_short_pre: 'This action removes your account, all transactions, connections and settings ',
    prof_delete_account_short_post: '.',
    prof_deleting: 'Deleting…',
    prof_delete_account_btn: 'Delete account',
    prof_delete_account_intro_pre: 'This action is ',
    prof_delete_account_intro_post: '. The following will be deleted:',
    prof_delete_item_txs: 'All transactions, settings and profile data',
    prof_delete_item_imports: 'Uploaded import files',
    prof_delete_item_login: 'Your sign-in account (email / Google login)',
    prof_delete_export_tip: 'Tip: export your data beforehand.',
    prof_delete_final_btn: 'Delete permanently',
    prof_export_failed: 'Export failed: {msg}',
    prof_account_delete_failed: 'Account deletion failed: {msg}',
    prof_unknown_error: 'Unknown error',
    prof_reauth_required: 'Please sign in again and retry (for security reasons).',
    prof_vip_err_used: 'This code has already been redeemed.',
    prof_vip_err_invalid: 'Unknown code. Please check your input.',
    prof_vip_err_empty: 'Please enter a code.',
    prof_vip_err_generic: 'Redemption failed. Please try again later.',
    prof_code_create_failed: 'Code could not be created.',

    // ── TransactionWizard ─────────────────────────────────────────
    tw_method_eyebrow: 'Add',
    tw_method_title: 'Record transaction',
    tw_method_sub: 'Captured completely, clearly in view.',
    tw_method_connect_label: 'Connect directly',
    tw_method_manual_sub: 'Enter buys, sells and transfers by hand.',
    tw_method_csv_sub: 'Upload exchange exports (Binance, Kraken, Coinbase, MoonPay…).',
    tw_method_api_sub: 'Connect read-only API keys for automatic tracking.',
    tw_method_wallet_title: 'Connect Phantom wallet',
    tw_method_wallet_sub: 'Connect Phantom — fetch swaps & transfers automatically.',
    tw_type_eyebrow: 'Step 1',
    tw_type_title: 'What did you do?',
    tw_type_sub: 'Choose the transaction type.',
    tw_type_buy_sub: 'Bought with fiat',
    tw_type_sell_sub: 'Sold for fiat',
    tw_type_swap_sub: 'Coin for coin',
    tw_type_received: 'Received',
    tw_type_received_sub: 'Transfer received',
    tw_type_sent: 'Sent',
    tw_type_fiat_in: 'Deposit',
    tw_type_fiat_in_sub: 'Cash to exchange',
    tw_type_fiat_out: 'Withdrawal',
    tw_type_fiat_out_sub: 'Cash to bank',
    tw_fiat_in_sub: 'Cash from your bank to an exchange.',
    tw_fiat_out_sub: 'Withdrawal from an exchange to your bank.',
    tw_type_sent_sub: 'Transfer sent',
    tw_type_reward: 'Reward',
    tw_type_reward_sub: 'Staking / interest',
    tw_type_staking: 'Staking',
    tw_type_staking_sub: 'Staking reward',
    tw_type_interest: 'Interest',
    tw_type_interest_sub: 'Lending yield',
    tw_type_airdrop: 'Airdrop',
    tw_type_airdrop_sub: 'Received for free',
    tw_type_loss: 'Loss',
    tw_type_loss_sub: 'Theft / hack',
    tw_type_futures: 'Futures PnL',
    tw_type_futures_sub: 'Gain / loss',
    tw_type_funding: 'Fee',
    tw_type_funding_sub: 'Funding fee',
    tw_pnl_label: 'Gain / loss',
    tw_pnl_ph: 'e.g. -50 or 120',
    tw_pnl_hint: 'Negative = loss/cost, positive = gain.',
    tw_coin_eyebrow: 'Step 2',
    tw_coin_title: 'Which coin?',
    tw_coin_sub: 'Search and pick a coin.',
    tw_coin_sub_selected: 'Tap another coin or continue.',
    tw_coin_search_ph: 'Bitcoin, ETH, XRP...',
    tw_coin_search_inline: 'Search coin...',
    tw_change: 'change',
    tw_src_title: 'What kind of transfer was this?',
    tw_src_sub: 'so we record the transaction correctly.',
    tw_src_own_in: 'From own wallet / exchange',
    tw_src_own_out: 'To own wallet / exchange',
    tw_src_own_sub: 'Transfer between my own wallets — automatically linked to its counterpart.',
    tw_src_ext_in: 'From friend / external person',
    tw_src_ext_out: 'To friend / external person',
    tw_src_ext_sub: 'No counter-transaction expected — will not be flagged as unmatched.',
    tw_src_gift_in: 'Gift received / as payment',
    tw_src_gift_out: 'Sent as gift / payment',
    tw_src_gift_sub_in: 'Recorded as an acquisition at market value.',
    tw_src_gift_sub_out: 'Recorded as a disposal at market value.',
    tw_src_own_short: 'Own wallet',
    tw_src_ext_short: 'External / friend',
    tw_details_eyebrow: 'Details',
    tw_details_sub: 'Enter the details.',
    tw_total: 'Total amount',
    tw_unit_price: 'Unit price',
    tw_unit_price_auto: 'Unit price (auto)',
    tw_value_at_time: 'Value at the time (optional)',
    tw_rate: 'Rate',
    tw_fee: 'Fee',
    tw_fee_incl: 'Fee (included in trade)',
    tw_network_fee: 'Network fee',
    tw_exchange: 'Exchange',
    tw_exchange_wallet: 'Exchange / wallet',
    tw_to_exchange: 'To which exchange',
    tw_from_exchange: 'From which exchange',
    tw_pick_exchange_title: 'Choose source',
    tw_pick_search: 'Search …',
    tw_pick_exchanges: 'Exchanges',
    tw_pick_hw: 'Hardware wallets',
    tw_pick_sw: 'Software wallets',
    tw_pick_other: 'Other',
    tw_pick_empty: 'Nothing found',
    tw_date_today: 'Today',
    tw_txhash: 'TX hash',
    tw_txhash_opt: 'TX hash (optional)',
    tw_note: 'Note',
    tw_note_opt: 'Note (optional)',
    tw_note_ph_dca: 'e.g. DCA, staking...',
    tw_note_ph_uniswap: 'e.g. Uniswap, DeFi...',
    tw_note_ph_from: 'e.g. from Bitpanda...',
    tw_note_ph_dca_airdrop: 'e.g. DCA, airdrop…',
    tw_swap_title: 'Swap details',
    tw_swap_sub: 'What did you swap for what?',
    tw_swap_coin_out: 'Coin given (from)',
    tw_swap_coin_in: 'Coin received (to)',
    tw_swap_amount_out: 'Amount given',
    tw_swap_amount_in: 'Amount received',
    tw_swap_value: 'Value of the swap',
    tw_hist_price_missing: 'No historical price found — please enter the value manually.',
    tw_transfer_external: 'External transfer',
    tw_transfer_in_title: 'Transfer received',
    tw_transfer_out_title: 'Transfer sent',
    tw_transfer_sub: 'enter date, amount and wallet.',
    tw_external_banner: 'No counterpart expected — the transaction will not be flagged.',
    tw_confirm_title: 'All correct?',
    tw_confirm_sub: 'Review your transaction.',
    tw_confirm_link_sub: 'Optional: link the matching counterpart.',
    tw_received_verb: 'received',
    tw_sent_verb: 'sent',
    tw_link_counterpart: 'Link counterpart (optional)',
    tw_no_counterpart_title: 'No matching counterpart found yet',
    tw_no_counterpart_sub: 'You can link this transaction manually after saving.',
    tw_save_and_link: 'Save & link',
    tw_save_transfer: 'Save transfer',
    // Connection section in the edit screen (web + mobile)
    conn_title: 'Connection',
    conn_linked_to: 'Linked to',
    conn_unlink: 'Disconnect',
    conn_suggestions: 'Possible counterparts',
    conn_link: 'Link',
    conn_none_hint: 'If the matching booking is missing (e.g. another exchange no longer exports the asset), create it here — it gets linked automatically.',
    conn_create: 'Create counterpart',
    conn_create_in: 'A deposit will be created as the counterpart.',
    conn_create_out: 'A withdrawal will be created as the counterpart.',
    conn_create_exchange: 'Source/target of the counterpart',
    conn_create_confirm: 'Create & link',
    conn_busy: 'One moment …',
    conn_wallet_label: 'Delivered to (wallet)',
    conn_wallet_none: '— none —',
    tw_back: 'Back',
    tw_src_root_title: 'Where bought?',
    tw_src_direct: 'Directly on the exchange',
    tw_src_direct_sub: 'e.g. Binance, Kraken, Bitvavo',
    tw_src_provider: 'Via payment provider',
    tw_src_provider_sub: 'e.g. MoonPay → Ledger',
    tw_pick_provider_title: 'Payment provider',
    tw_pick_dest_title: 'Delivered where?',
    tw_gift: 'Gift',
    tw_verb_kauf: 'bought',
    tw_verb_verkauf: 'sold',
    tw_verb_staking: 'received as reward',
    tw_verb_airdrop: 'received as airdrop',
    tw_verb_loss: 'lost',
    tw_verb_einzahlung: 'received',
    tw_verb_auszahlung: 'sent',
    tw_save_x: 'Save {x}',
    tw_transaction: 'Transaction',
    tw_edit: 'Edit',
    tw_edit_swap: 'Edit swap',
    tw_tx_type: 'Transaction type',
    tw_what_transfer: 'What kind of transfer?',
    tw_fiat_buy_q: 'Was this a fiat purchase?',
    tw_switch: 'Switch',
    tw_countervalue: 'Countervalue: {v} — record as a buy',
    tw_save_changes: 'Save changes',
    tw_locked: 'Locked',
    tw_copy: 'Copy',
    tw_fee_detected_reduced: 'Detected fee: {amt} — already deducted from the received amount.',
    tw_fee_detected_increased: 'Detected fee: {amt} — already added to the amount given.',
    tw_fee_detected_separate: 'Detected fee: {amt} — recorded as a separate fee transaction.',

    // ── Transaction rows (TxRow / TxCards / WalletDesktopTable) ────
    tx_derived_value_tip: 'Derived from the historical daily closing price',
    tx_dust_badge: 'DUST',
    tx_dust_tip: 'Micro-deposit with no value — typical address poisoning (a stranger sends worthless amounts to appear in your history). Hidden from the main list, viewable in the “Other” tab.',
    tx_asset: 'Asset',
    tx_source: 'Source',
    tx_none: 'No transactions',
    tx_unknown: 'Unknown',
    tx_yesterday: 'Yesterday',
    tx_transfer: 'Transfer',
    tx_internal_transfer: 'internal transfer',
    tx_linked_manually: 'linked manually',
    tx_fee_short: 'Fee',
    tx_fee: 'Fee',
    tx_fee_in_spread: 'Fee in spread',
    tx_fee_spread_tip: 'Bitpanda Consumer charges fees via the exchange rate (spread). The amount cannot be determined through the API — the transaction is NOT actually fee-free.',
    tx_edit: 'Edit',
    tx_delete: 'Delete',
    tx_unlink_transfer: 'Unlink transfer',
    tx_unlink_confirm: 'Remove the link? Both entries will appear separately again.',
    tx_cancel: 'Cancel',
    tx_unlink_confirm_yes: 'Yes, unlink',
    tx_inflow: 'Inflow',
    tx_outflow: 'Outflow',
    tx_external_wallet: 'External wallet',
    tx_own_wallet: 'Own wallet',
    tx_wallet_suffix: '{name} wallet',
    tx_counterpart: 'Counterpart: {date}',
    tx_no_counterpart: 'No counterpart found',
    tx_suggested: 'Suggested · {score} %',
    tx_onchain: 'on-chain',
    tx_sent_from: 'Sent from',
    tx_received_on: 'Received on',
    tx_from: 'From',
    tx_to: 'To',
    tx_own_wallet_suffix: 'own wallet',
    tx_external_short: 'External wallet',
    tx_hl_transferred: 'transferred',
    tx_hl_sent: 'sent',
    tx_hl_received: 'received',
    tx_funding_fee: 'Fee',
    tx_liquidation: 'Liquidation',
    tx_futures_pnl: 'Futures PnL',
    tx_consumed: 'consumed',
    tx_gained: 'gained',

    // ── CommandPalette ────────────────────────────────────────────
    cmd_group_pages: 'Pages',
    cmd_group_actions: 'Actions',
    cmd_group_coins: 'Coins',
    cmd_placeholder: 'Jump to page, coin or action …',
    cmd_no_results: 'No matches.',
    cmd_open_alerts: 'Open alerts',
    cmd_light_mode: 'Switch to light mode',
    cmd_dark_mode: 'Switch to dark mode',
    cmd_lang_en: 'Language: English',
    cmd_lang_de: 'Language: German',

    // ── ImportReviewScreen ────────────────────────────────────────
    imp_title: 'Review import',
    imp_unknownExchange: 'Unknown exchange',
    imp_transactions: 'Transactions',
    imp_transactions_checked: 'Transactions checked',
    imp_ready_short: 'Ready to import',
    imp_aiConfidence: 'AI confidence',
    imp_confAuto: 'Auto-import possible',
    imp_confReview: 'Please review',
    imp_confManual: 'Check manually',
    imp_needsAttention_one: '{n} transaction needs your attention',
    imp_needsAttention_other: '{n} transactions need your attention',
    imp_readyToImport: '{n} transactions ready to import',
    imp_recognized_clean: 'All {n} recognized cleanly',
    imp_recognized_some: '{ok} recognized cleanly · {n} to review',
    imp_datacheck_pointer_one: '1 item to clarify later in the data check',
    imp_datacheck_pointer_other: '{n} items to clarify later in the data check',
    imp_chain_match_title: 'Matches the blockchain',
    imp_chain_match_body: 'Your calculated balance matches exactly what is currently on the address — nothing missing, nothing duplicated.',
    imp_chain_balance: 'Balance',
    imp_chain_mismatch_title: 'Balance differs slightly',
    imp_chain_mismatch_body: 'The calculated balance differs from what is on the address. A few older transactions are probably missing.',
    imp_chain_computed: 'Calculated',
    imp_chain_onchain: 'On the address',
    imp_chain_mismatch_hint: 'View in the data check — resolves once the missing transactions are added',
    // Cold start „connect your first source" (ConnectFirstSource)
    cfs_title: 'Get your portfolio in, {name}.',
    cfs_title_noname: 'Get your portfolio in.',
    cfs_sub: 'Connect a source — we reconcile it directly against the blockchain. You see right away whether everything is fully captured.',
    cfs_exchange_title: 'Connect exchange',
    cfs_exchange_sub: 'Read-only keys · automatic tracking',
    cfs_trust_exchange: 'reconciled with the exchange',
    cfs_wallet_title: 'Wallet address',
    cfs_wallet_sub: 'BTC · ETH · SOL · XRP · ADA · XLM — by address or xpub',
    cfs_trust_chain: 'reconciled with the blockchain',
    cfs_csv_title: 'Upload CSV',
    cfs_csv_sub: 'Exchange export (Binance, Kraken, Coinbase …)',
    cfs_manual_title: 'Add manually',
    cfs_manual_sub: 'Buys, sells & transfers by hand',
    cfs_direct: 'Connect directly',
    cfs_privacy: 'Read-only · keys encrypted · we never sell data',
    cfs_skip: 'Skip',
    imp_clickToEdit: 'Click to edit',
    imp_remove: 'Remove',
    imp_importing: 'Importing…',
    imp_importApproved: 'Import {n} approved',
    imp_replaceAndImport: 'Replace old & import {n}',
    imp_importOk: 'Import {n} OK',
    imp_importAll: 'Import all {n}',
    imp_staleTitle: 'Will be updated',
    imp_staleBody: 'These {n} {exchange} transactions replace an earlier import and are recreated with the current calculation — your holdings stay correct, nothing is lost.',
    imp_conflictTitle: 'Already present',
    imp_conflictBody_one: '{n} of these transactions is already in your portfolio and is skipped automatically — no duplicate import.',
    imp_conflictBody_other: '{n} of these transactions are already in your portfolio and are skipped automatically — no duplicate import.',
    imp_moonpayTitle: '{n} MoonPay purchases → Ledger wallet will be merged',
    imp_moonpayBody: 'These Ledger deposits are the on-chain delivery of your MoonPay purchases. Instead of two entries per purchase you get one combined entry: purchase price from MoonPay, on-chain hash and wallet info from Ledger.',
    imp_swapMergeTitle: '{n} swap delivery(ies) will be merged',
    imp_swapMergeBody: 'These on-chain deposits are the delivery of a swap you already recorded. They are merged into the swap instead of double-counted.',
    imp_willMerge: 'Merged',
    imp_reviewedOf: '{n} of {total} reviewed',
    imp_filterAll: 'All',
    imp_cat_merged: 'Merged',
    imp_cat_existing: 'Already present',
    imp_showMore: '+ Show {n} more',
    imp_emptyCategory: 'No transactions in this category',
    imp_lowConfTitle: 'Low AI confidence',
    imp_lowConfBody: 'Please review the transactions carefully. Faulty entries are not imported.',
    // Automatic import audit (auditImport) — internal consistency checks, no target input
    imp_audit_nondeterministic_title: 'Calculation not stable',
    imp_audit_nondeterministic_body: 'The balance of {coins} depends on the order of transactions — that is a calculation error, not your fault. Please don\'t save yet and report this import to us.',
    imp_willImport: 'Will import',
    imp_alreadyExistsSkipped: 'Already present · skipped',
    imp_withErrorSkipped: 'With error · skipped',
    imp_importAllNoErrors: 'Import all without errors ({n})',

    // ── AlertWizard ───────────────────────────────────────────────
    aw_type_price_above_sub: 'When the coin rises above a threshold.',
    aw_type_price_below_sub: 'When the coin falls below a threshold.',
    aw_type_pct_change: '% move 24h',
    aw_type_pct_change_sub: 'When the coin moves by X%.',
    aw_type_holding_period_sub: 'The 1-year period of your position is approaching.',
    aw_type_position_value: 'Position value',
    aw_type_position_value_sub: 'The value of your coin position reaches a threshold.',
    aw_type_portfolio_value: 'Portfolio value',
    aw_type_portfolio_value_sub: 'Your total portfolio reaches a threshold.',
    aw_title_push_l1: 'Enable',
    aw_title_push_l2: 'push',
    aw_title_coin_l1: 'Choose',
    aw_title_coin_l2: 'coin',
    aw_title_type_l1: 'Choose',
    aw_title_type_l2: 'alert',
    aw_title_threshold_l1: 'Set',
    aw_title_threshold_l2: 'threshold',
    aw_title_review: 'Overview',
    aw_sub_push: 'We only send push notifications for alerts you created yourself. No ads. Can be disabled anytime.',
    aw_sub_coin: 'A coin from your portfolio or another one.',
    aw_sub_type: 'When should we notify you?',
    aw_sub_threshold_coin: 'Threshold for {coin}.',
    aw_sub_threshold: 'At which threshold should it trigger?',
    aw_sub_review: 'One last look before we create the alert.',
    aw_err_enable_failed: 'Activation failed.',
    aw_err_create_failed: 'Creation failed.',
    aw_ios_title: 'On iPhone',
    aw_ios_hint_pre: 'In Safari, push only works if you add red. to the ',
    aw_ios_hint_home: 'home screen',
    aw_ios_hint_post: ' and open it from there.',
    aw_enable_push: 'Enable push',
    aw_enable_later: 'Enable later',
    aw_privacy_pre: 'Details in the',
    aw_privacy_link: 'privacy policy',
    aw_privacy_post: '.',
    aw_from_portfolio: 'From your portfolio',
    aw_other_coin: 'Other coin',
    aw_coin_input_ph: 'CoinGecko ID, e.g. bitcoin',
    aw_choose: 'Choose',
    aw_unit_day: 'day',
    aw_unit_days: 'days',
    aw_caps_lead_time: 'Lead time',
    aw_caps_portfolio_threshold: 'Portfolio threshold',
    aw_caps_move_24h: 'Move in 24h',
    aw_caps_threshold_up: 'Threshold up',
    aw_caps_threshold_down: 'Threshold down',
    aw_current_price: 'Currently {price} {sym}',
    aw_n_day: '{n} day',
    aw_n_days: '{n} days',
    aw_portfolio: 'Portfolio',
    aw_verb_above: 'above',
    aw_verb_below: 'below',
    aw_verb_reaches: 'reaches',
    aw_review_holding_lead: 'Reaches the',
    aw_review_holding_connector: '1-year period — heads-up in',
    aw_review_portfolio_lead: 'Reaches',
    aw_review_portfolio_connector: 'a value of',
    aw_review_move_lead: 'Moves ',
    aw_review_move_lead_pct: 'Moves by',
    aw_review_at_least: 'at least',
    aw_recurring: 'Recurring',
    aw_recurring_on: 'At least 24h cooldown between triggers.',
    aw_recurring_off: 'Triggers only once, then deactivates.',
    aw_create_alert: 'Create alert',

    // ── Onboarding / Login ────────────────────────────────────────
    auth_welcome_title: 'Welcome,',
    auth_welcome_sub: 'red. is your personal crypto companion.',
    auth_welcome_privacy: 'Private, encrypted, visible only in your account.',
    auth_lets_go: 'Let\'s go',
    auth_name_title: 'What\'s your name?',
    auth_name_sub: 'Your name appears in the app and on exported overview documents.',
    auth_name_placeholder: 'First name or pseudonym',
    auth_name_hint: 'Used only for your own exports (PDF / Excel). Never shared with third parties. A pseudonym is fine.',
    auth_country_title: 'Which country do you live in?',
    auth_country_sub: 'Determines which features are relevant for you.',
    auth_country_de_sub: 'FIFO · 1-year holding period',
    auth_country_at_sub: 'Moving average',
    auth_hero_sub: 'Your entire crypto portfolio. Live. Read-only, non-custodial, no data selling.',
    auth_continue_google: 'Continue with Google',
    auth_continue_apple: 'Continue with Apple',
    auth_continue_email: 'Continue with email',
    auth_or: 'or',
    auth_no_account: 'No account yet?',
    auth_register: 'Sign up',
    auth_login_title: 'Sign in',
    auth_login_loading: 'Signing in…',
    auth_email: 'Email',
    auth_password: 'Password',
    auth_password_min: 'Password (min. 6 characters)',
    auth_forgot_password: 'Forgot password?',
    auth_register_title: 'Create account',
    auth_register_loading: 'Creating account…',
    auth_reset_title: 'Reset password',
    auth_reset_sub: 'We\'ll send you a reset link.',
    auth_reset_sent: 'Link sent! Check your inbox.',
    auth_reset_cta: 'Send link',
    auth_reset_loading: 'Sending…',
    auth_back_to_login: 'Back to sign in',
    auth_privacy_note: 'Your portfolio data is private — visible only in your account.',
    auth_consent_pre: 'By signing in you accept our',
    auth_consent_and: 'and',
    auth_err_user_not_found: 'No account found with this email.',
    auth_err_wrong_password: 'Incorrect password.',
    auth_err_invalid_credential: 'Email or password incorrect.',
    auth_err_email_in_use: 'This email is already registered.',
    auth_err_weak_password: 'Password must be at least 6 characters.',
    auth_err_invalid_email: 'Invalid email address.',
    auth_err_too_many_requests: 'Too many attempts. Please try again later.',
    auth_err_enter_email: 'Please enter your email.',
    auth_err_generic: 'Sign-in failed. Please try again.',

    // ── red/ SmartCheck / Timeline / Analyse ──────────────────────
    red_sc_available_after_period: 'of your {sym} holdings become available after the 1‑year period ends.',
    red_sc_today: 'today',
    red_sc_next_tranche_in: 'Next tranche free in',
    red_sc_days: 'days',
    // ── red/ Release agenda (holding-period overview, DE) ─────────
    red_ag_all_coins: 'All coins',
    red_ag_title: 'Releases',
    red_ag_sub: 'When each tranche passes the 1-year period — across your entire portfolio.',
    red_ag_hero_caption: 'of your holdings are free to use',
    red_ag_free_caption: 'free · today',
    red_ag_next_releases: 'Upcoming releases',
    red_ag_bucket_soon: 'Soon · next 90 days',
    red_ag_bucket_later_year: 'Later in {year}',
    red_ag_bound_left: 'still bound',
    red_ag_all_free: 'All tranches are outside the period.',
    red_ag_days_unit: 'days',
    red_ag_reminder: 'Remind me on release',
    red_ag_reminder_sub: 'Push as soon as a tranche frees up',
    red_ag_axis_toggle: 'Show or hide timeline',
    // ── Data check (completeness, profile/dashboard) ──────────────
    dc_kicker: 'Data check',
    dc_title: 'Does your picture add up?',
    dc_sub: 'We reconcile your holdings against connected sources and show what still needs clearing up. All local, from your data.',
    dc_all_clear: 'All reconciled',
    dc_to_clarify: 'points to clear up',
    dc_rest_clear: 'the rest of your picture is reconciled',
    dc_sources_live: 'sources connected',
    dc_sect_open: 'To clear up',
    dc_open_transfer: '{n} transfers without counterpart',
    dc_open_transfer_one: '1 transfer without counterpart',
    dc_open_transfer_hint: 'own transfer or a real buy?',
    dc_external: '{n} external receipts',
    dc_external_one: '1 external receipt',
    dc_external_hint: 'gift, own wallet or bought elsewhere?',
    dc_cta_assign: 'Assign',
    dc_no_basis: '{n} tranches without cost basis',
    dc_no_basis_one: '1 tranche without cost basis',
    dc_no_basis_from: 'from',
    dc_no_basis_hint: 'no reliable value without a basis',
    dc_cta_complete: 'Add',
    dc_sect_sources: 'Your sources',
    dc_tx_count: '{n} transactions',
    dc_src_api: 'API connected',
    dc_src_chain: 'Address watched · on-chain',
    dc_src_csv: 'CSV import',
    dc_src_manual: 'Entered manually',
    dc_status_connected: 'connected',
    dc_status_imported: 'imported',
    dc_status_manual: 'manual',
    dc_dust: '{n} possible scam-dust entries hidden',
    dc_note: 'Other tools quietly miscalculate when a transfer or cost basis is missing. red. surfaces the gaps — loud, not silent.',
    dc_open: 'Data check',
    dc_fix_title: 'To clear up',
    dc_fix_sub: 'These {n} transactions still need clearing up. Tap one to assign the counterpart or add the purchase price.',
    dc_fix_empty: 'All clear — no open transactions.',
    dc_fix_sect_transfer: 'Without counterpart',
    dc_fix_sect_external: 'Received externally — assign source',
    dc_fix_sect_basis: 'Without cost basis',
    dc_fix_hint: 'A missing counterpart means the inflow is not linked to a withdrawal yet. Without a purchase price the report treats the tranche conservatively — real buys are worth completing.',
    red_tl_no_open_tranches: 'No open FIFO tranches for {sym}.',
    red_tl_hero_l1: 'of your {sym} holdings',
    red_tl_hero_l2: 'past the 1-year period',
    red_tl_next_pre: 'In',
    red_tl_next_days: '{days} days',
    red_tl_next_mid: 'another',
    red_tl_next_post: 'will pass the period.',
    red_tl_today: 'Today',
    red_tl_bound: 'bound',
    red_aa_close: 'Close',
    red_aa_avg_buy: 'Avg. buy',
    red_aa_per: 'per {sym}',
    red_aa_buys_one: '{n} buy',
    red_aa_buys_many: '{n} buys',
    red_aa_hero_up: 'Up versus your deposits',
    red_aa_hero_down: 'Down versus your deposits',
    red_aa_hero_even: 'Break-even',
    red_aa_return: '% return',
    red_aa_cashflow: 'Cash flow',
    red_aa_deposited: 'Deposited',
    red_aa_deposited_sub: 'Fiat buys + stablecoin bridges',
    red_aa_withdrawn: 'Already taken out',
    red_aa_sells_one: '{n} sale',
    red_aa_sells_many: '{n} sales',
    red_aa_no_sells: 'No sales yet',
    red_aa_holding_today: 'Holdings today',
    red_aa_total_perf: 'Total performance:',
    red_aa_summary_pre: 'So far you have put',
    red_aa_summary_invested: ' into {name}.',
    red_aa_summary_of_which: 'Of that you have already',
    red_aa_summary_withdrawn: ' taken back out.',
    red_aa_summary_no_sells: 'No sales have been made yet.',
    red_aa_summary_remaining: 'Your remaining holdings ({amount} {sym}) are worth',
    red_aa_summary_worth: ' today.',
    red_aa_disclaimer: 'Calculations are based on recorded EUR values. Stablecoin swaps are valued via pegging (1:1). Market prices: CoinGecko · red. is not a tax advisor.',

    // ── red/ Market widgets (MarketIndices / LiveTicker / PromoCard) ─
    wid_market_live: 'Market · Live',
    wid_loading: 'LOADING',
    wid_close: 'Close',
    wid_live: 'LIVE',
    wid_ago_min: '{min} min ago',
    wid_source: 'Data · {src}',
    wid_history_30d: 'History · 30 days',
    wid_30_days: '30 DAYS',
    wid_30_days_inline: '30 days',
    wid_yesterday: 'Yesterday',
    wid_last_week: 'A week ago',
    wid_last_month: 'A month ago',
    wid_neutral: 'Neutral',
    wid_neutral_s: 'NEUTRAL',
    wid_fg_title: 'Fear & Greed · Index',
    wid_fg_extreme_fear: 'Extreme Fear',
    wid_fg_extreme_fear_s: 'EXTR. FEAR',
    wid_fg_fear: 'Fear',
    wid_fg_fear_s: 'FEAR',
    wid_fg_greed: 'Greed',
    wid_fg_greed_s: 'GREED',
    wid_fg_extreme_greed: 'Extreme Greed',
    wid_fg_extreme_greed_s: 'EXTR. GREED',
    wid_scale_fear_lo: '0 · Fear',
    wid_scale_greed_hi: 'Greed · 100',
    wid_fg_info_title: 'What does the index measure?',
    wid_fg_info_pre: 'Crypto-market sentiment from ',
    wid_fg_info_mid: ' (extreme fear) to ',
    wid_fg_info_post: ' (extreme greed) — from volatility, volume, social media, dominance and trends. Low values often signal buying opportunities, high values caution.',
    wid_btcd_title: 'Bitcoin · Dominance',
    wid_btcd_weak: 'BTC weak',
    wid_btcd_alt_phase_s: 'ALT PHASE',
    wid_btcd_strong: 'BTC strong',
    wid_btcd_strong_s: 'BTC STRONG',
    wid_btcd_dominant: 'BTC dominant',
    wid_btcd_dominant_s: 'DOMINANT',
    wid_stablecoins: 'Stablecoins',
    wid_rest_market: 'Rest of market',
    wid_total_mcap: 'Total market cap',
    wid_vol_24h: 'Vol. 24h',
    wid_btcd_info_title: 'What is BTC dominance?',
    wid_btcd_info_body: 'Bitcoin\'s share of the total market capitalization of all cryptocurrencies. When it rises, capital flows from altcoins back into BTC (risk-off). When it falls, altcoins gain relatively — often a precursor to altseason.',
    wid_total_title: 'Crypto · Total market',
    wid_total_tile: 'Total market',
    wid_total_alt_mcap: 'Alt market · excl. BTC',
    wid_total_assets: 'Active coins',
    wid_total_composition: 'Market weight',
    wid_total_history: 'History',
    wid_no_history: 'No history available',
    wid_r_7d: '7D',
    wid_r_30d: '30D',
    wid_r_90d: '90D',
    wid_r_1y: '1Y',
    wid_total_info_title: 'What is total market cap?',
    wid_total_info_body: 'The combined value of every cryptocurrency — price × circulating supply, summed across the whole market. It shows how much capital sits in crypto overall. The alt market strips out Bitcoin to reveal how the rest is moving.',
    wid_unit_trillion: 'T',
    wid_unit_billion: 'B',
    wid_unit_million: 'M',
    wid_alt_title: 'Altcoin · Season Index',
    wid_alt_btc_season: 'Bitcoin Season',
    wid_alt_btc_season_s: 'BTC SEASON',
    wid_alt_btc_pref: 'BTC favored',
    wid_alt_mixed: 'Mixed',
    wid_alt_mixed_s: 'MIXED',
    wid_alt_altseason: 'Altseason',
    wid_alt_altseason_s: 'ALTSEASON',
    wid_alt_beat_btc: '{out}/{total} beat BTC',
    wid_scale_btc_season_lo: '0 · Bitcoin season',
    wid_scale_altseason_hi: 'Altseason · 100',
    wid_top_outperformers: 'Top movers · 30 days',
    wid_btc_30d: 'Bitcoin · 30 days',
    wid_alt_outperform_label: 'Altcoins beating BTC',
    wid_alt_info_title: 'How is it calculated?',
    wid_alt_info_pre: 'Share of the top-50 coins (excluding stablecoins and wrapped tokens) that outperformed Bitcoin over the last ',
    wid_alt_info_mid: '. ',
    wid_alt_info_mid2: ' counts as altseason, ',
    wid_alt_info_post: ' as Bitcoin Season.',
    wid_alt_source: 'Data · CoinGecko · Method per BlockchainCenter',
    // Calm redesign of the market indices (one unified build)
    wid_btcd_title_calm: 'Bitcoin dominance',
    wid_alt_title_calm: 'Altseason',
    wid_fg_sub: 'Crypto-market sentiment',
    wid_btcd_sub: "Bitcoin's share of the market",
    wid_alt_sub: 'Are altcoins beating Bitcoin?',
    wid_total_sub: 'Combined value of all crypto',
    wid_scale_btcd_lo: '0 · Altcoins',
    wid_scale_btcd_hi: 'Only Bitcoin · 100',
    wid_vs_yesterday: 'vs. yesterday',
    wid_last_24h: 'over the last 24h',
    wid_plan: 'Plan',
    wid_activate: 'Activate',
    wid_vip_tagline: 'Lifetime · Concierge support',
    wid_promo_price: '€49/year',

    // ── Modals/Sheets (ExportSheet / LimitGate / Support / Bell) ──
    mod_export_eyebrow_asset: 'Analysis',
    mod_export_eyebrow_report: 'Report',
    mod_export_asset_title: 'Export {name}',
    mod_export_report_title: 'Export report',
    mod_export_sub_asset: 'Choose the format. Both include an overview, a disposal breakdown (per acquisition) and all transactions.',
    mod_export_sub_year: 'Choose the format. Both include a disposal breakdown per acquisition, allocation and all transactions.',
    mod_export_report_year: 'Report year',
    mod_export_pdf_sub: 'Print-ready & branded',
    mod_export_xlsx_sub: 'Freely filter & sort',
    mod_export_unlock_pre: 'Unlock with',
    mod_export_unlock_report: 'Report',
    mod_export_unlock_asset_pre: 'Asset export with',
    mod_export_footer_ready: 'Generated server-side and downloaded automatically.',
    mod_per_year_suffix: '/year',
    mod_limit_unlimited: 'unlimited',
    mod_limit_title_exceed: 'Import would exceed your limit',
    mod_limit_title_block: 'Limit reached for {year}',
    mod_limit_sub_exceed: 'You want to import {n} transactions, but only {fit} still fit in your {year} account.',
    mod_limit_sub_block: 'Your plan allows {limit} transactions per year. For {year} you have already entered {count}.',
    mod_limit_year_label: 'Year {year}',
    mod_limit_recommendation: 'Recommendation',
    mod_limit_features: '{limit} transactions per year · AI import · Excel & PDF reports · API connections',
    mod_limit_view_plans: 'View plans →',
    mod_limit_later: 'Later',
    mod_limit_reassure: 'Existing transactions are kept. You can still view everything.',
    mod_support_title: 'Contact support',
    mod_support_sub: 'Where does the issue occur? We\'ll create a diagnostics file with your transactions for you to attach to the email — no passwords or keys.',
    mod_support_footer_pre: 'Opens your email app to',
    mod_support_app: 'App',
    mod_support_app_sub: 'iOS & Android',
    mod_support_pc: 'PC',
    mod_support_pc_sub: 'Web in the browser',
    mod_support_mail_subject: 'Support request',
    mod_support_mail_desc: 'Description of the issue:',
    mod_support_mail_platform: 'Platform',
    mod_support_mail_platform_app: 'App (mobile)',
    mod_support_mail_platform_web: 'Web (PC)',
    mod_support_mail_tx: 'Transactions',
    mod_support_mail_origin: 'Origin',
    mod_support_mail_version: 'Version',
    mod_support_mail_plan: 'Plan',
    mod_support_mail_attach: 'IMPORTANT: Please attach the file „{file}" you just downloaded to this email — it helps us reproduce your issue (contains no passwords or keys).',
    mod_bell_title: 'Notifications',
    mod_bell_just_now: 'just now',
    mod_bell_min_ago: '{n} min ago',
    mod_bell_hr_ago: '{n} hr ago',
    mod_bell_day_ago: '{n} day ago',
    mod_bell_days_ago: '{n} days ago',
    mod_bell_empty_title: 'No alerts yet',
    mod_bell_empty_sub: 'As soon as an alert triggers, it appears here.',
    mod_bell_fired: 'Alert triggered',
    mod_bell_manage_all: 'Manage all alerts ›',
    mod_bell_clear_expired: 'Clear expired',

    // ── Connect flows (Solana / API / Privacy / LinkTransfer) ─────
    con_phantom_title: 'Connect Phantom Wallet',
    con_how_it_works: 'How it works',
    con_phantom_how_body: 'Connect Phantom directly or paste your Solana address manually. We fetch your full on-chain transaction history and automatically classify swaps (Jupiter/Raydium), transfers and spam airdrops.',
    con_phantom_opening: 'Opening Phantom…',
    con_phantom_connect: 'Connect with Phantom',
    con_phantom_open_app: 'Open in Phantom app',
    con_phantom_install: 'Install Phantom',
    con_phantom_connected: 'Phantom connected',
    con_disconnect: 'Disconnect',
    con_or_manual: 'OR MANUALLY',
    con_sol_address: 'Solana address',
    con_sol_addr_base58: 'Address must be 32-44 Base58 characters long.',
    con_label_optional: 'Label (optional)',
    con_label_placeholder: 'e.g. Phantom, Backpack, Ledger-SOL',
    con_label_hint: 'Shown as the exchange name — handy if you have several Solana wallets.',
    con_error: 'Error',
    con_status: 'Status',
    con_import: 'Import',
    con_sol_loading_txs: 'Loading Solana transactions…',
    con_sol_readonly_note: 'Note: read-only access — we cannot execute any transactions, only read your on-chain history. Your address is publicly visible on the Solana blockchain and is not stored by us.',
    con_phantom_not_found: 'Phantom not found. Install the browser extension from phantom.app and reload the page.',
    con_phantom_no_address: 'Phantom did not return a valid address.',
    con_phantom_rejected: 'Connection rejected in Phantom.',
    con_phantom_failed: 'Phantom connection failed.',
    con_sol_addr_invalid_paste: 'Please paste a valid Solana address (32-44 characters).',
    con_error_status: 'Error {status}',
    con_sol_no_txs: 'No transactions found for {addr}…',
    con_sol_parsed: '{parsed} of {fetched} transactions detected — opening review.',
    con_sol_sync_failed: 'Solana sync failed.',
    // ── UTXO wallet import (Bitcoin & co. via Blockchair) ──
    tw_method_utxo_title: 'Wallet address',
    tw_method_utxo_sub: 'BTC, ETH, Solana, XRP & more — by address or xpub',
    cwc_title: 'Connect Bitcoin & Wallets',
    cwc_how_body: 'Pick the chain and paste an address or an xpub/zpub. We fetch the full on-chain history (deposits/withdrawals + fees) automatically. An xpub covers your entire wallet.',
    cwc_chain: 'Blockchain',
    cwc_value_label: 'Address or xpub',
    cwc_value_label_addr: 'Address',
    cwc_value_placeholder: 'e.g. bc1q… or xpub6C…',
    cwc_value_placeholder_addr: 'Your wallet\'s public address',
    cwc_value_hint_addr: 'Your wallet\'s public address. Account chains like Stellar have no xpub — one address = the whole account.',
    cwc_value_hint_ada: 'Cardano: paste your stake address (stake1…) — it covers your ENTIRE wallet. A single addr1… only captures part of it.',
    cwc_value_hint_evm: 'EVM address (0x…) — it works across all EVM networks. Pick the network you traded on above (the same address can be active on several networks).',
    cwc_skipped: '{count} unknown tokens skipped ({names}). Only clearly identifiable coins are imported — no spam. Missing a real coin? Add it manually.',
    cwc_wallet_name: 'Wallet',
    cwc_wallet_name_ph: 'e.g. Ledger',
    cwc_wallet_name_hint: 'Sets how this source is named in your transactions (e.g. “MoonPay → Ledger”).',
    cwc_wallet_select: 'Choose wallet…',
    cwc_pick_title: 'Choose wallet',
    cwc_pick_sub: 'Use a saved wallet or pick a brand.',
    cwc_pick_brand: 'Brand',
    cwc_my_wallets: 'My wallets',
    cwc_new_wallet: 'Add new wallet',
    cwc_pick_search: 'Search…',
    cwc_pick_use: 'Use:',
    wr_title: 'My wallets',
    wr_card_sub: 'Save your addresses — imports get named automatically.',
    wr_how_title: 'Save your addresses once',
    wr_how_body: 'Store your own wallet addresses with a name (e.g. “Ledger”, “MetaMask”). When you import a known address it gets named correctly automatically — no “→ ETH”, no manual relabeling. Your data only; addresses are public on-chain anyway.',
    wr_name: 'Wallet name',
    wr_name_ph: 'e.g. Ledger, MetaMask',
    wr_chain: 'Chain',
    wr_address: 'Address',
    wr_address_ph: 'Paste public address',
    wr_address_ph_utxo: 'Paste address or xpub',
    wr_add: 'Save wallet',
    wr_saving: 'Saving…',
    wr_saved: 'Saved ({n})',
    wr_empty: 'No wallets saved yet.',
    wr_invalid: 'Please enter a name and a valid address.',
    wr_failed: 'Saving failed.',
    wr_known: 'Known wallet',
    wr_pick: 'Pick from “My wallets”',
    wr_add_cta: 'Add wallet',
    wr_step_wallet: 'Which wallet?',
    wr_step_wallet_sub: 'Pick your wallet — hardware or software.',
    wr_step_chain: 'Which chain?',
    wr_step_chain_sub: 'Which network is your {wallet} address on?',
    wr_step_address: 'Paste address',
    wr_hw: 'Hardware wallets',
    wr_sw: 'Software wallets',
    wr_other_sec: 'Other',
    wr_other_name_ph: 'Name of your wallet',
    wr_next: 'Continue',
    wr_addr_help: 'Your wallet’s public receive address — just copy it from the wallet.',
    wr_addr_help_xpub: 'Advanced: an xpub/zpub captures your entire hardware wallet at once (optional, instead of a single address).',
    wr_watch: 'Watch automatically',
    wr_watch_sub: 'Check daily for new activity',
    wr_own: 'My own wallet',
    wr_own_sub: 'Transfers here don’t count as a sale',
    wr_review_title: 'To review',
    wr_review_hint: 'Detected automatically — confirm briefly, then it’s cleanly in.',
    wr_review_open: 'Review all ({n})',
    wr_review_src: 'Wallet monitoring',
    wr_auto_imported: '{n} imported automatically (transfer between your wallets)',
    cwc_preview_cta: 'Check wallet',
    cwc_preview_title: 'Preview — review before import',
    cwc_preview_body: '{count} transactions will be imported ({coins}).',
    cwc_preview_confirm: 'Import {count}',
    cwc_preview_pricing: 'Loading prices… ({done}/{total})',
    cwc_preview_cancel: 'Cancel',
    cwc_overlap_title: 'Possible duplicates',
    cwc_overlap_body: 'Some of these coins are already in your portfolio ({coins}). If you already recorded them via CSV or an exchange, importing will create duplicates — double-check your transactions afterwards.',
    cwc_xpub_hint: 'Address = just this one address. xpub/zpub (from a hardware wallet, e.g. Ledger) = the whole wallet with all addresses — recommended.',
    cwc_address: 'address',
    cwc_loading: 'Loading {name} transactions…',
    cwc_readonly_note: 'Read-only access. Your address/xpub is public on the blockchain and is not stored by us — the request only goes through our backend to the blockchain data provider.',
    cwc_value_invalid: 'Please paste a valid address or xpub.',
    cwc_no_txs: 'No transactions found for {addr}…',
    cwc_parsed: '{parsed} transactions detected ({kind}) — opening review.',
    cwc_failed: 'Wallet import failed.',
    cwc_backfill_title: 'Backfill missing prices',
    cwc_backfill_body: '{n} imported transactions without a EUR value. Backfill historical daily prices via CoinGecko.',
    cwc_backfill_cta: 'Backfill prices',
    cwc_backfill_running: 'Loading prices… {done}/{total}',
    cwc_backfill_done: 'Backfilled {patched} of {total} transactions.',
    cwc_backfill_toast: 'Backfilled {n} prices',
    con_moonpay_title: 'Clean up MoonPay duplicates',
    con_moonpay_body: '{n} wallet deposits match a MoonPay purchase. The wallet entry is removed and the MoonPay purchase additionally receives the wallet info.',
    con_moonpay_cleanup_btn: 'Clean up {n} pairs',
    con_moonpay_cleaned: '{n} MoonPay wallet pairs cleaned up.',
    con_processing: 'Processing…',
    con_backfill_title: 'Load missing prices',
    con_backfill_body: 'Found {n} existing transactions without a value. Historical daily prices are fetched via CoinGecko.',
    con_backfill_btn: 'Load prices for {n} TX',
    con_backfill_loading: 'Loading prices… {done}/{total}',
    con_backfill_done: '{patched} of {total} TX backfilled with a price.',
    con_backfill_hint_prefix: 'Note: {hints}.',
    con_backfill_hint_too_old: '{n} daily-price lookups are more than 365 days in the past — the free CoinGecko demo tier does not provide historical prices for those (Pro key required, or add the value manually)',
    con_backfill_hint_no_key: 'no CoinGecko API key configured on the server',
    con_backfill_hint_rate_limit: 'CoinGecko rate limit reached — try again later',
    con_backfill_hint_not_found: '{n} without an available daily price',
    con_backfill_toast_ok: '✓ {n} TX priced',
    con_backfill_toast_none: 'No prices backfilled — see note',
    con_exchange_api: 'Exchange API',
    con_exchange_api_sub: 'Connect read-only keys — automatic tracking of your transactions.',
    con_premium_feature: 'Premium feature',
    con_api_sync_premium: 'API sync is part of the Premium tier. You can create connections, but you need Premium to sync.',
    con_view_plans: 'View plans',
    con_load_connections_failed: 'Could not load connections.',
    con_sync_warning: 'Note: {warnings}',
    con_sync_success: 'Sync successful: {count} new transactions ({trades} trades, {ledger} ledger, {skipped} skipped)',
    con_sync_failed: 'Sync failed.',
    con_delete_confirm: 'Really remove "{label}"?\nYour previously imported transactions are kept.',
    con_connection_removed: 'Connection removed.',
    con_delete_failed: 'Deletion failed.',
    con_connection_saved: 'Connection saved.',
    con_loading_connections: 'Loading connections…',
    con_no_connections: 'No connections yet',
    con_no_connections_sub: 'Connect your first exchange to import transactions automatically.',
    con_connect_new_exchange: '+ Connect new exchange',
    con_never: 'Never',
    con_last_sync: 'Last sync: {time}',
    con_syncing: 'Syncing…',
    con_sync_now: 'Sync now',
    con_remove: 'Remove',
    con_choose_exchange: 'Choose exchange',
    con_soon: 'Soon',
    con_choose_other: 'Choose another',
    con_create_readonly_key: 'Create a read-only key',
    con_readonly_important_pre: 'Important: create a ',
    con_readonly_key_strong: 'read-only key',
    con_readonly_important_post: ' (no trading, no withdrawals).',
    con_scope_note_binance: 'Note: For Binance, deposits/withdrawals, fiat purchases and spot trades are imported. Convert, Earn & staking rewards are not included yet — the balance check after the sync will show any gaps.',
    con_reconcile_ok: 'Balances match the exchange ✓ ({matches} coins checked)',
    con_reconcile_mismatch: 'Heads up: {count} coin(s) differ from the exchange balance — transactions may be missing. Please add them via CSV if needed: {detail}',
    con_reconcile_partial: 'Note: Balance reconciliation is not yet available for this exchange (spot trades coming soon).',
    con_open_guide: 'Open guide ↗',
    con_designation_optional: 'Label (optional)',
    con_designation_placeholder: 'e.g. "My {exchange} account"',
    con_api_key: 'API key',
    con_api_key_placeholder: 'Paste API key here',
    con_api_secret: 'API secret',
    con_passphrase: 'Passphrase',
    con_passphrase_placeholder: 'Passphrase from the exchange setup',
    con_connection_ok: 'Connection OK',
    con_connection_failed: 'Connection failed',
    con_credentials_work: 'The credentials work. You can save the connection now.',
    con_testing: 'Testing…',
    con_test: 'Test',
    con_saving: 'Saving…',
    con_save_failed: 'Could not save.',
    con_privacy_sub: 'What data is processed — and how you stay in control.',
    con_priv_ai_title: 'AI analysis',
    con_priv_ai_body_pre: 'For automatic detection of CSV, Excel, PDF or image files, the file content is transferred to ',
    con_priv_ai_body_post: ' (data processing under EU standard contractual clauses). Per the Google API terms, the content is not used for model training and not shared with other users.',
    con_priv_local_title: 'What stays local',
    con_priv_local_body: 'Known exchange formats (Binance, Bitpanda, Kraken, Coinbase and others) are processed by a local parser first. In those cases your file never leaves the browser — the AI only steps in when the local parser does not recognize a format.',
    con_priv_store_title: 'What we store',
    con_priv_store_body_pre: 'In your private area (',
    con_priv_store_body_post: '): your confirmed transactions, the import history and auto-reviews. In a technical schema database we only store the column structure of known formats — no transaction contents.',
    con_priv_retention_title: 'Retention period',
    con_priv_retention_body: 'Import logs are deleted automatically after 24 months. Your transaction data is kept until you delete it yourself or close your account.',
    con_priv_rights_title: 'Your rights (Art. 15–22 GDPR)',
    con_priv_rights_body: 'You can request access, rectification, erasure or data portability at any time. When you delete your account, all data attributable to you is removed.',
    con_priv_consent_loading: 'Loading consent status…',
    con_priv_consent_active: 'AI consent active',
    con_priv_consent_active_body: 'Granted on {date}. You can withdraw your consent at any time.',
    con_priv_consent_none: 'No AI consent granted',
    con_priv_consent_none_body: 'Currently only the local parser runs. You will be asked automatically on your next upload.',
    con_priv_revoking: 'Revoking…',
    con_priv_revoke: 'Revoke AI consent',
    con_transfer_confirm_title: 'Confirm transfer',
    con_transfer_confirm_sub: 'Review the entries before you link them.',
    con_source: 'Source',
    con_target: 'Target',
    con_amount_sent: 'Amount sent',
    con_amount_received: 'Amount received',
    con_difference: 'Difference',
    con_network_fee: 'Network fee',
    con_time_difference: 'Time difference',
    con_currency: 'Currency',
    con_time_under_min: 'under 1 min',
    con_time_min: '{n} min',
    con_time_hrs: '{n} h',
    con_time_days: '{n} days',
    con_quality_strong: 'Very strong match',
    con_quality_medium: 'Possible match',
    con_quality_weak: 'Weak match',
    con_linking: 'Linking…',
    con_link_as_transfer: 'Link as transfer',

    // ── Misc (App / UpdateBanner / SwipeAction / Settings-CSV) ────
    misc_update_title: 'New version available',
    misc_update_body: 'Reload briefly so all calculations are up to date.',
    misc_update_reload: 'Reload',
    misc_hide: 'Hide',
    misc_csv_import_title: 'Import file',
    misc_csv_import_sub: 'CSV, Excel, PDF or screenshot — AI detects the format automatically and imports all transactions.',
    misc_csv_analyzing: 'AI is analyzing CSV…',
    misc_csv_analyzing_sub: 'This may take a few seconds',
    misc_csv_drop_title: 'Drop file here',
    misc_csv_drop_sub: 'CSV, Excel, PDF, image — or click to select',
    misc_csv_err_no_tx: 'AI could not detect any transactions. Please check the file format.',
    misc_csv_err_connection: 'Connection error. Please try again.',
    misc_onboard_welcome: 'Welcome',
    misc_onboard_headline_1: 'Add your first',
    misc_onboard_headline_2: 'transaction.',
    misc_onboard_body_desktop_pre: 'Click ',
    misc_onboard_body_desktop_post: ' (＋) on the left in the navigation bar to start a buy, sell or CSV import.',
    misc_onboard_body_mobile_pre: 'Tap the ',
    misc_onboard_body_mobile_post: ' in the center at the bottom to start a buy, sell or CSV import.',
    misc_onboard_cta: 'Let\'s go',
  },
};

export function translate(lang, key, vars) {
  const bundle = STR[lang] || STR.de;
  let s = bundle[key] || STR.de[key] || key;
  if (vars) {
    Object.keys(vars).forEach(k => {
      s = s.replace(new RegExp(`\\{${k}\\}`, 'g'), vars[k]);
    });
  }
  return s;
}
